webpackJsonp([0],Array(26).concat([
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(74)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(116),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ed828b3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_bulma_css__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_bulma_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_bulma_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_youtube__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_youtube___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_youtube__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_youtube___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(45)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(68),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_header__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_footer__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_footer__);
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Ssheader: __WEBPACK_IMPORTED_MODULE_0__components_header_vue___default.a,
    Ssfooter: __WEBPACK_IMPORTED_MODULE_2__components_footer_vue___default.a,
    trHeader: __WEBPACK_IMPORTED_MODULE_1__views_header___default.a,
    trFooter: __WEBPACK_IMPORTED_MODULE_3__views_footer___default.a
  },
  name: 'app',
  data: function data() {
    return {
      msg: 'SarıkayaŞahin Web Development by Kaan KÜÇÜK'
    };
  }
});

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(49)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(55),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swiperx_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swiperx_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__swiperx_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    swiperx: __WEBPACK_IMPORTED_MODULE_0__swiperx_vue___default.a
  },
  name: 'header',
  data: function data() {
    return {
      msg: 'SarıkayaŞahin Web Development by Kaan KÜÇÜK',
      menuData: [{ name: 'Home', path: '', isActive: false, a: 'activate' }, { name: 'about us', path: 'about-us', isActive: false }, { name: 'PRACTICE AREAS', path: 'practice-areas', isActive: false }, { name: 'OUR TEAM', path: 'our-team', isActive: false }, { name: 'PUBLICATIONS', path: 'publications', isActive: false }, { name: 'CONTACT', path: 'contact', isActive: false }, { name: 'TR', path: 'tr', isActive: false }, { name: 'EN', path: '', isActive: false }],
      navMenu: false
    };
  },

  methods: {
    activate: function activate() {
      this.navMenu = !navMenu;
      console.log(this.navMenu);
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(52)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'swiperx',
  data: function data() {
    return {
      swiperOption: {
        autoplay: 3000
      }
    };
  }
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('swiper', {
    ref: "mySwiper",
    staticClass: "content",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide'), _vm._v(" "), _c('swiper-slide', [_c('h2', [_vm._v("HAKKIMIZDA")])]), _vm._v(" "), _c('swiper-slide', [_c('h2', [_vm._v("FAALİYET ALANLARI")])]), _vm._v(" "), _c('swiper-slide', [_c('h2', [_vm._v("EKİBİMİZ")])]), _vm._v(" "), _c('swiper-slide', [_c('h2', [_vm._v("YAYINLAR")])]), _vm._v(" "), _c('swiper-slide', [_c('h2', [_vm._v("İLETİŞİM")])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Ssheader"
  }, [_c('nav', {
    staticClass: "navbar container is-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu navk",
    class: {
      navMenu: _vm.navMenu
    }
  }, _vm._l((_vm.menuData), function(menu, index) {
    return _c('router-link', {
      key: ("" + index),
      staticClass: "navbar-item ",
      class: {
        active: menu.isActive
      },
      attrs: {
        "to": ("/" + (menu.path))
      },
      nativeOn: {
        "click": function($event) {
          _vm.navMenu = !_vm.navMenu
        }
      }
    }, [_vm._v(_vm._s(menu.name))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger",
    on: {
      "click": function($event) {
        _vm.navMenu = !_vm.navMenu
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    staticClass: "navbar-item",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/sarikayaSahinLogo.png",
      "alt": "Sarıkayaşahin Hukuk"
    }
  })])])
}]}

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(57)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(59),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'tr-header',
  data: function data() {
    return {
      menuData: [{ name: 'Anasayfa', path: 'tr', isActive: false, a: 'activate' }, { name: 'Hakkımızda', path: 'tr/hakkimizda', isActive: false }, { name: 'Faalİyet Alanları', path: 'tr/hukuk-faaliyet-alanlari', isActive: false }, { name: 'EKİBİMİZ', path: 'tr/ekibimiz', isActive: false }, { name: 'BÜLTEN', path: 'tr/bulten', isActive: false }, { name: 'YAYINLAR', path: 'tr/yayinlar', isActive: false }, { name: 'İletİşİm', path: 'tr/iletisim', isActive: false }, { name: 'TR', path: 'tr', isActive: false }, { name: 'EN', path: '', isActive: false }],
      navMenu: false
    };
  },

  methods: {
    activate: function activate() {
      this.navMenu = !navMenu;
      console.log(this.navMenu);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Ssheader"
  }, [_c('nav', {
    staticClass: "navbar container is-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu navk",
    class: {
      navMenu: _vm.navMenu
    }
  }, _vm._l((_vm.menuData), function(menu) {
    return _c('router-link', {
      key: ("" + (menu.index)),
      staticClass: "navbar-item ",
      class: {
        active: menu.isActive
      },
      attrs: {
        "to": ("/" + (menu.path))
      },
      nativeOn: {
        "click": function($event) {
          _vm.navMenu = !_vm.navMenu
        }
      }
    }, [_vm._v(_vm._s(menu.name))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger",
    on: {
      "click": function($event) {
        _vm.navMenu = !_vm.navMenu
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    staticClass: "navbar-item",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/sarikayaSahinLogo.png",
      "alt": "Sarıkayaşahin Hukuk"
    }
  })])])
}]}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(61)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f1b8c950",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    components: {},
    name: 'Ssfooter',
    data: function data() {
        return {
            msg: 'SarıkayaŞahin Web Development by Kaan KÜÇÜK'
        };
    },

    computed: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Ssfooter has-text-left"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-1 is-3-mobile"
  }, [_c('router-link', {
    attrs: {
      "to": "/privacy-policy"
    }
  }, [_c('p', [_vm._v("Privacy Policy")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-1 is-3-mobile"
  }, [_c('router-link', {
    attrs: {
      "to": "/cookie-policy"
    }
  }, [_c('p', [_vm._v("Cookie Policy")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-1 is-3-mobile"
  }, [_c('router-link', {
    attrs: {
      "to": "/legal-notices"
    }
  }, [_c('p', [_vm._v("Legal Notices")])])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-8 has-text-centered is-12-mobile"
  }, [(this.$root._route.meta.policy) ? _c('p', [_vm._v("This website uses cookies. Please read more from cookie policy.")]) : _c('p')]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-3-mobile is-hidden-desktop"
  }, [_c('img', {
    attrs: {
      "src": "/static/ssl.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-1 is-12-mobile is-hidden-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/ssl.png"
    }
  })])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(65)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(67),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-29b90530",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'tr-footer',
  data: function data() {
    return {
      msg: 'SarıkayaŞahin Web Development by Kaan KÜÇÜK'
    };
  },

  computed: {}
});

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Ssfooter has-text-left"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-1 is-3-mobile"
  }, [_c('router-link', {
    attrs: {
      "to": "/tr/gizlilik-politikasi"
    }
  }, [_c('p', [_vm._v("Gizlik Politikası")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-1 is-3-mobile"
  }, [_c('router-link', {
    attrs: {
      "to": "/tr/cerez-politikasi"
    }
  }, [_c('p', [_vm._v("Çerez Politikası")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-1 is-3-mobile"
  }, [_c('router-link', {
    attrs: {
      "to": "/tr/yasal-bildirimler"
    }
  }, [_c('p', [_vm._v("Yasal Bildirimler")])])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-8 has-text-centered is-12-mobile"
  }, [(this.$root._route.meta.policy) ? _c('p', [_vm._v("Bu sitede çerez kullanılmaktadır. Daha fazla bilgi için lütfen çerez politikasını okuyunuz.")]) : _c('p')]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-3-mobile is-hidden-desktop"
  }, [_c('img', {
    attrs: {
      "src": "/static/ssl.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-1 is-12-mobile is-hidden-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/ssl.png"
    }
  })])
}]}

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(this.$root._route.meta.tur) ? _c('trHeader') : _c('Ssheader'), _vm._v(" "), _c('router-view'), _vm._v(" "), (this.$root._route.meta.tur) ? _c('trFooter') : _c('Ssfooter')], 1)
},staticRenderFns: []}

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_homepage__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_homepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pages_homepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_aboutus__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_aboutus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_aboutus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_practice_areas__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_practice_areas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_practice_areas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_our_team__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_our_team___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_our_team__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_publications__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_publications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pages_publications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_contact__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_pages_contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_privacy_policy__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_privacy_policy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pages_privacy_policy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_cookie_policy__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_cookie_policy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_pages_cookie_policy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_legal_notices__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_legal_notices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_pages_legal_notices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_turkish__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_turkish___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_turkish__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__tr__ = __webpack_require__(155);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'homepage',
    component: __WEBPACK_IMPORTED_MODULE_2__components_pages_homepage___default.a,
    meta: { policy: true }
  }, {
    path: '/tr',
    component: __WEBPACK_IMPORTED_MODULE_11__views_turkish___default.a,
    children: __WEBPACK_IMPORTED_MODULE_12__tr__["a" /* tr */]
  }, {
    path: '/about-us',
    name: 'aboutUs',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages_aboutus___default.a,
    meta: { policy: false }
  }, {
    path: '/practice-areas',
    name: 'practiceAreas',
    component: __WEBPACK_IMPORTED_MODULE_4__components_pages_practice_areas___default.a
  }, {
    path: '/our-team',
    name: 'ourTeam',
    component: __WEBPACK_IMPORTED_MODULE_5__components_pages_our_team___default.a
  }, {
    path: '/publications',
    name: 'publications',
    component: __WEBPACK_IMPORTED_MODULE_6__components_pages_publications___default.a
  }, {
    path: '/contact',
    name: 'contact',
    component: __WEBPACK_IMPORTED_MODULE_7__components_pages_contact___default.a
  }, {
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: __WEBPACK_IMPORTED_MODULE_8__components_pages_privacy_policy___default.a
  }, {
    path: '/cookie-policy',
    name: 'cookiePolicy',
    component: __WEBPACK_IMPORTED_MODULE_9__components_pages_cookie_policy___default.a
  }, {
    path: '/legal-notices',
    name: 'legalNotices',
    component: __WEBPACK_IMPORTED_MODULE_10__components_pages_legal_notices___default.a
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(72)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(118),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-398fdf96",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_videoBg_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_videoBg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_videoBg_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    videoBg: __WEBPACK_IMPORTED_MODULE_0__components_videoBg_vue___default.a
  },
  name: 'hello',
  data: function data() {
    return {};
  },

  // mounted() {
  //     if (this.$root._route.meta.policy) {
  //       this.policy = true
  //       console.log('DENEMEDİR')
  //   } else {
  //       this.policy = false
  //   }
  // },
  computed: {}
});

/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'videoBg',
  data: function data() {
    return {
      playerVars: {
        autoplay: 1,
        playlist: 'W0LHTWG-UmQ',
        loop: true,
        setLoop: true
      }
    };
  },

  methods: {
    playVideo: function playVideo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$refs.test.play();

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0, 'CANT PLAYED');

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 5]]);
      }))();
    }
  },
  computed: {
    width: function width() {
      return window.innerWidth;
    },
    height: function height() {
      return window.innerHeight;
    }
  },
  mounted: function mounted() {

    console.log(this.$refs);
    this.playVideo();
  }
});

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-background"
  }, [_c('div', {
    staticClass: "video-foreground"
  }, [_c('video', {
    ref: "test",
    attrs: {
      "controls": "",
      "src": __webpack_require__(117),
      "width": _vm.width,
      "height": _vm.height,
      "videoWidth": _vm.width,
      "videoHeight": _vm.height,
      "autoplay": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "videoOverlay"
  })])
},staticRenderFns: []}

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sarikayasahinVideo.62f4cd7.mp4";

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "griddy-contain"
  }, [_vm._m(0), _vm._v(" "), _c('videoBg')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "griddy container is-flui"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-hidden-mobile"
  }, [_c('h1', [_vm._v("SARIKAYA\n          "), _c('span', {
    staticClass: "plus"
  }, [_vm._v("+")]), _vm._v(" "), _c('span', {
    staticClass: "s"
  }, [_vm._v("S")]), _vm._v("AH"), _c('span', {
    staticClass: "i"
  }, [_vm._v("I")]), _vm._v("N")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Today, the impact of rapid changes in technology and economy is also manifested in the field of law. Therefore, these changes bring the necessity for dynamic, open-minded and professionally up-to-date lawyers more than ever. Sarıkaya + Şahin aims to respond to these necessities while enhancing its services to come along with the best possible solutions.")]), _vm._v(" "), _c('span', {
    staticClass: "liner"
  })])])])
}]}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(120)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(122),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-198bfc1a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'aboutUs',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "aboutUs"
  }, [_c('div', {
    staticClass: "section is-medium"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("ABOUT US")])]), _vm._v(" "), _c('div', {
    staticClass: "column tile is-parent is-vertical"
  }, [_c('p', {
    staticClass: "tile is-child"
  }, [_vm._v("Today, the impact of rapid changes in technology and economy is also manifested in the field of law. Therefore, these changes bring the necessity for dynamic, open-minded and professionally up-to-date lawyers more than ever. Sarıkaya + Şahin aims to respond to these necessities while enhancing its services to come along with the best possible solutions.")]), _vm._v(" "), _c('p', {
    staticClass: "tile is-child"
  }, [_vm._v("Sarıkaya + Şahin focuses on providing high level advice and expertise to its clients for their legal obstacles in various commercial areas in order to materialise their business strategies and assist them to achieve their goals. Sarıkaya + Şahin counsels clients of all types – individuals, entrepreneurs, small businesses and start-ups and international and global entities.")]), _vm._v(" "), _c('p', {
    staticClass: "tile is-child"
  }, [_vm._v("By putting forward solution-oriented and interest efficient approaches, Sarıkaya + Şahin is dedicated to provide excellence in client service.")]), _vm._v(" "), _c('p', {
    staticClass: "tile is-child"
  }, [_vm._v("In matters of relations with administrative body and institutions, pursuing and concluding licence, authorization and permit procedures, Sarıkaya + Şahin collaborates with Uğur Poyraz Law Firm based in Ankara with 20 years of experience.")])])])])])]), _vm._v(" "), _c('span', {
    staticClass: "uplogo"
  }, [_c('img', {
    attrs: {
      "src": "/static/upLogo.png"
    }
  })])])
}]}

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(124)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2202cf1c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'practiceAreas',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "practiceAreas"
  }, [_c('div', {
    staticClass: "section is-medium"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("PRACTICE AREAS")])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('span', {
    staticClass: "plusActive"
  }), _vm._v(" "), _c('div', {
    staticClass: "tile is-vertical is-12"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child notification "
  }, [_c('ul', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('li', [_vm._v("Intellectual Property")]), _vm._v(" "), _c('li', [_vm._v("Information Technology and E-Commerce")]), _vm._v(" "), _c('li', [_vm._v("Domain Names and Telecommunication")]), _vm._v(" "), _c('li', [_vm._v("Data Privacy")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child notification"
  }, [_c('ul', {
    staticClass: "has-text-right is-parent is-vertical tile"
  }, [_c('li', [_vm._v("Maritime and Transportation")]), _vm._v(" "), _c('li', [_vm._v("Aviation Law")]), _vm._v(" "), _c('li', [_vm._v("Customs and Ports")]), _vm._v(" "), _c('li', [_vm._v("Work and Residence Permits")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child notification"
  }, [_c('ul', {
    staticClass: "has-text-left is-parent is-vertical tile"
  }, [_c('li', [_vm._v("Litigation and Commercial Disputes")]), _vm._v(" "), _c('li', [_vm._v("Contracts Law")]), _vm._v(" "), _c('li', [_vm._v("Real Property")]), _vm._v(" "), _c('li', [_vm._v("Construction Law")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child notification"
  }, [_c('ul', {
    staticClass: "has-text-right is-parent is-vertical tile"
  }, [_c('li', [_vm._v("Start-Ups and International Investments")]), _vm._v(" "), _c('li', [_vm._v("Permits, Licences and Authorization")]), _vm._v(" "), _c('li', [_vm._v("Media, Entertainment and Fashion")]), _vm._v(" "), _c('li', [_vm._v("Sports Law")])])])])])])])])])])])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(128)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(130),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a6e06834",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ourTeam',
  data: function data() {
    return {
      isActive: false,
      isActive2: false,
      isActive3: false,
      isActive4: false,
      isActive5: false,
      isActive6: false,
      isActive7: false,
      isActive8: false
    };
  },

  methods: {
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    toggle2: function toggle2() {
      this.isActive2 = !this.isActive2;
    },
    toggle3: function toggle3() {
      this.isActive3 = !this.isActive3;
    },
    toggle4: function toggle4() {
      this.isActive4 = !this.isActive4;
    },
    toggle5: function toggle5() {
      this.isActive5 = !this.isActive5;
    },
    toggle6: function toggle6() {
      this.isActive6 = !this.isActive6;
    },
    toggle7: function toggle7() {
      this.isActive7 = !this.isActive7;
    },
    toggle8: function toggle8() {
      this.isActive8 = !this.isActive8;
    }
  }
  // mounted () {
  //     x = document.getElementsByClassName('extra');
  //     console.log(x);
  // }
});

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ourTeam"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-vertical"
  }, [_c('div', {
    staticClass: "tile"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tile columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("Burçak Sercan Sarıkaya")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("sarikaya@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle2
    }
  }, [_vm._v("Onur Şahin")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("sahin@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive2
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle2
    }
  })])])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "tile columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle3
    }
  }, [_vm._v("Ali Rıza Aksoy")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("aksoy@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive3
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle3
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle4
    }
  }, [_vm._v("Halil Çolak")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("colak@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive4
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle4
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle5
    }
  }, [_vm._v("Hüseyin Alp İlker")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("ilker@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive5
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle5
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle7
    }
  }, [_vm._v("Rafet Emin Demir")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("demir@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive7
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle7
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle8
    }
  }, [_vm._v("Uğur Fırtına")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("firtina@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive8
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle8
    }
  })])])])])]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "tile colums"
  }, [_c('div', {
    staticClass: "column is-half paddingless"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle6
    }
  }, [_vm._v("Onur Uraz")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("uraz@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive6
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle6
    }
  })])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-parent is-3 is-vertical"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("OUR TEAM")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-child  has-text-right is-size-1"
  }, [_c('h2', [_vm._v("FOUNDING PARTNERS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/burcakSarikaya.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Burçak Sercan Sarıkaya")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Education")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Atılım University Insitute of Social Sciences (Ph.D in Business\n                                      Administration, present)\n                                    ")]), _vm._v(" "), _c('li', [_vm._v("Bahçeşehir University Institute of Social Sciences (LL.M in Private Law – Full\n                                      Scholarship)\n                                    ")]), _vm._v(" "), _c('li', [_vm._v("Ankara University Faculty of Law (Law Diploma)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("MEMBERSHIPS & ADMISSIONS")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("ELSA")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Other Languages")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("English")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/onurSahin.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Onur Şahin")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Education")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Galatasaray University Insitute of Social Sciences (Ph.D in Private Law,\n                                      present)\n                                    ")]), _vm._v(" "), _c('li', [_vm._v("University of Glasgow Faculty of Law (LL.M in Intellectual Property and the\n                                      Digital Economy)\n                                    ")]), _vm._v(" "), _c('li', [_vm._v("Galatasaray University Institute of Social Sciences (LL.M in Private Law)")]), _vm._v(" "), _c('li', [_vm._v("Ankara University Faculty of Law (Law Diploma)")]), _vm._v(" "), _c('li', [_vm._v("University of Passau Faculty of Law (Erasmus Exchange Program)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("MEMBERSHIPS & ADMISSIONS")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Trademark Attorney")]), _vm._v(" "), _c('li', [_vm._v("Patent Attorney")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Other Languages")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("English")]), _vm._v(" "), _c('li', [_vm._v("Basic conversational/reading knowledge in German")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-child  has-text-right is-size-1"
  }, [_c('h2', [_vm._v("ATTORNEYS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/aliRiza.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Ali Rıza Aksoy")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Education")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Ankara University Faculty of Law (Law Diploma)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Other Languages")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("English")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/halil.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Halil Çolak")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Education")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Ankara University Faculty of Law (Law Diploma)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Other Languages")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("English")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/alp.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Hüseyin Alp İlker")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Education")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Galatasaray University Institute of Social Sciences (LL.M in Private Law)")]), _vm._v(" "), _c('li', [_vm._v("Ankara University Faculty of Law (Law Diploma)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Other Languages")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("English")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/rafet.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Rafet Emin Demir")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Education")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Galatasaray University Institute of Social Sciences (LL.M in Private Law)")]), _vm._v(" "), _c('li', [_vm._v("Ankara University Faculty of Law (Law Diploma)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Other Languages")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("English")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/ugur.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Uğur Fırtına ")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Education")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Ankara University Faculty of Law (Law Diploma)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Other Languages")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("English")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-child  has-text-right is-size-1"
  }, [_c('h2', [_vm._v("OF COUNSEL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/onur.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Onur Uraz")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Education")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("University of Southampton (Ph.D. in International Criminal Law)")]), _vm._v(" "), _c('li', [_vm._v("University of Glasgow (LL.M. in International Public Law)")]), _vm._v(" "), _c('li', [_vm._v("Gazi University Faculty of Law (Law Diploma)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("MEMBERSHIPS & ADMISSIONS")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Editor - Southampton Student Law Review (2017)")]), _vm._v(" "), _c('li', [_vm._v("Member of Board of Management - Ankara Bar Review(ABR)")]), _vm._v(" "), _c('li', [_vm._v("International Association of Genocide Scholars")]), _vm._v(" "), _c('li', [_vm._v("European Society of International Law")]), _vm._v(" "), _c('li', [_vm._v("The Centre for Law, Policy and Society (Southampton University)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Other Languages")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("English")])])])])])])])
}]}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(132)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(134),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7f4696ef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'publications',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publications"
  }, [_c('div', {
    staticClass: "section is-medium"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column tile is-parent is-vertical is-6"
  }, [_c('span', {}, [_c('ul', [_c('H3', [_vm._v("ARTICLES")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Duty of Buyer to Mitigate Damages under the CISG")]), _c('br'), _vm._v(" "), _vm._m(1), _c('br'), _vm._v(" "), _vm._m(2), _c('br'), _vm._v(" "), _vm._m(3), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Termination of Surety and Guarantee Contracts")]), _c('br'), _vm._v(" "), _vm._m(4), _c('br'), _vm._v(" "), _vm._m(5), _c('br'), _vm._v(" "), _vm._m(6), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("The Past, the Present and the Future of Colour and Smell Marks")]), _c('br'), _vm._v(" "), _vm._m(7), _c('br'), _vm._v(" "), _vm._m(8), _c('br'), _vm._v(" "), _vm._m(9), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Should Copyright Law Protect Advertising Slogans")]), _c('br'), _vm._v(" "), _vm._m(10), _c('br'), _vm._v(" "), _vm._m(11), _c('br'), _vm._v(" "), _vm._m(12), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("TV Copycatting: Determining the Threshold Between Legal Copying and Copyright Infringement")]), _c('br'), _vm._v(" "), _vm._m(13), _c('br'), _vm._v(" "), _vm._m(14), _c('br'), _vm._v(" "), _vm._m(15), _c('br')], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Jurisdiction Agreements under Administrative Law")]), _c('br'), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('ul', [_c('H3', [_vm._v("BOOKS")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Termination of Professional Football Player’s Contract and the Resolution Process of The Disputes Arising from Termination")]), _c('br'), _vm._v(" "), _vm._m(17), _c('br'), _vm._v(" "), _vm._m(18), _c('br'), _vm._v(" "), _vm._m(19), _c('br')], 1), _vm._v(" "), _c('ul', [_c('H3', [_vm._v("SEMINARS")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Seminar organized by the Istanbul Bar Association and Istanbul Bilgi University on the Recent Problems of Maritime Enforcement Law")]), _c('br'), _vm._v(" "), _vm._m(20), _c('br')], 1), _vm._v(" "), _c('ul', [_c('H3', [_vm._v("NEWS")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Pros and Cons of the New Regulation Regarding Yachts Flying With Foreign Flag")]), _c('br'), _vm._v(" "), _vm._m(21), _c('br'), _vm._v(" "), _vm._m(22), _c('br')], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("PUBLICATIONS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Publication Date")]), _vm._v(" : Dec 16, 2016")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Publisher")]), _vm._v(" : Galatasaray University Law Review 2016 - 2")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Abstract")]), _vm._v(" Under the United Nation Convention on the International Sale of Goods (CISG), both parties have the duty to mitigate losses. In practise, it is observed that the buyer usually relies on a breach of contract and consequently, most of the time, it is the buyer who has the duty to mitigate damages. Under the duty of mitigation of damages, the buyer must take reasonable measures to mitigate his losses. If he fails to take reasonable measures, he must bear the amount of damages which should have been mitigated. Theoretically, the concept of the duty to mitigate damages is clear, though it might cause uncertainties in practice. It is not always so easy for parties, courts and arbitral tribunals to determine which measures are reasonable under which conditions.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Publication Date")]), _vm._v(" : Sep 1, 2016")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Publisher")]), _vm._v(" : Union of Turkish Bar Association Review 126, 311-338.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Abstract")]), _vm._v(" Surety and guarantee contracts are the most common types of personal guarantee contracts. Although they have some resembling aspects, there are significant differences when it comes to termination. The foremost reason is that a guarantee contract is independent from the underlying contract, on the other hand, a surety contract has ancillary character. In addition, the termination of surety contract is enacted in the Turkish Code of Obligations but there is no regulation on termination of guarantee contract.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Publication Date")]), _vm._v(" : Aug 1, 2016")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Publisher")]), _vm._v(" : European Intellectual Property Review 38(8), 504-516")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Abstract")]), _vm._v(" Non-traditional trade marks have become part of commerce and advertising but they continue to struggle in finding a place in the current EU trade mark system. The reason for this, simply, is that the current EU trade mark system is based on traditional trade marks, such as words, names, letters and logos. However, the system has been pushed increasingly by traders wanting to register non-traditional trade marks. This paper specifically focuses on colour and smell trade marks and tries to set out how these kinds of non-traditional trade marks can be registrable under the EU law. In this context, there are two main obstacles; the graphical representation requirement and the distinctiveness requirement. Registration problems of non-traditional trade marks impelled the European Commission to revise the current situation of the functioning of the EU trade mark system and this has resulted in proposals for, both, a new trade mark Directive and Regulation. These proposals suggested to abolish the graphical representation requirement and to include colours and sounds as examples for signs that may constitute a trade mark.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Publication Date")]), _vm._v(" : Mar 1, 2016")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Publisher")]), _vm._v(" : European Intellectual Property Review 38, Issue 3, 172-177")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Abstract")]), _vm._v(" Advertisements might have different motives in their creation process but it is not possible to deny that they are important outcomes of intellectual creations. An important part of advertising activities is advertising slogans. Some of them can be protected by trademark law but this paper focuses on the potential copyright aspect of advertising slogans. On the one hand, they are different than other types of copyright works because they are too short but on the other hand, some of them are capable of conveying ideas and emotions. In this paper, different arguments against and for providing copyright protection to advertising slogans are going to be discussed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Publication Date")]), _vm._v(" : Apr 30, 2015")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Publisher")]), _vm._v(" : Gazi University Law Review 19, Issue 2, 137-148")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Abstract")]), _vm._v(" TV formats are so popular and widely traded all around the world. Therefore, they lead highly-profitable business and this turns TV formats into precious assets. Hence, it is essential to protect these assets in legal context. The problem is that TV formats are composed of ideas and concepts and these are not under protectionof copyright law. So, is it free to copy a whole format? Of course not, but there is a thin and blurry line between legal copying and copyright infringement. This paper aims to provide help on the determination of the threshold between legal copying and copyright infringement.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('strong', [_vm._v("Publication Date")]), _vm._v(" : November, 2009")]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Publisher")]), _vm._v(" : Mahalli İdareler Aylık Mesleki ve Mevzuat Dergisi, Issue 183, 35-38.")]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Abstract")]), _vm._v(" Although it is clear that jurisdiction agreements are possible under private law, it is a debate whether it is possible to enter into jurisdiction agreement under administrative law. Auction process no doubt falls within the administrative law. Within this process, administrative specifications and agreements may contain articles regarding competent courts. Local courts might dismiss the case by relying on these articles. However, since there is no specific rule, there exists legal gap and this Article concentrates on the question of whether jurisdiction agreements are possible under administrative law.")]), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Publication Date")]), _vm._v(" : Dec 29, 2016")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Publisher")]), _vm._v(" : On İki Levha Yayıncılık A. Ş.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Abstract")]), _vm._v(" Professional football players’ contracts have a substantial role in professional football, as they regulate the legal relationship between players and clubs. Because of the self-enclosed characteristic of professional football, it is usually not possible to come across with disputes which are made a matter of law between players and clubs..")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Date")]), _vm._v(" : 13 May, 2017")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Date")]), _vm._v(" : April, 2017")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Description")]), _vm._v(" PARA – Weekly Financial Magazine")])
}]}

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(136)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7cd900a8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact',
  data: function data() {
    return {};
  },

  mounted: function mounted() {
    //   let locate = null;
    //   window.innerWidth > 500 ? locate = {lat: 41.0620881, lng: 29.0098528} : locate =  {lat: 41.0805581, lng: 29.0217118};
    //   let map = new google.maps.Map(document.getElementById('map'), {
    //     center: locate,
    //     zoom: 15,
    //     styles: [
    //       {
    //         "featureType": "administrative",
    //         "elementType": "labels.text.fill",
    //         "stylers": [
    //           {
    //             "color": "#444444"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "landscape",
    //         "elementType": "all",
    //         "stylers": [
    //           {
    //             "color": "#f2f2f2"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "landscape.man_made",
    //         "elementType": "geometry.stroke",
    //         "stylers": [
    //           {
    //             "visibility": "simplified"
    //           },
    //           {
    //             "color": "#f70000"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "landscape.natural.landcover",
    //         "elementType": "all",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "landscape.natural.terrain",
    //         "elementType": "geometry",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "landscape.natural.terrain",
    //         "elementType": "labels.text",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "landscape.natural.terrain",
    //         "elementType": "labels.icon",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "poi",
    //         "elementType": "all",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "poi.attraction",
    //         "elementType": "labels.icon",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "poi.park",
    //         "elementType": "geometry.fill",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           },
    //           {
    //             "color": "#a9f07e"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "poi.park",
    //         "elementType": "labels.text.fill",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "poi.park",
    //         "elementType": "labels.icon",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           },
    //           {
    //             "hue": "#2dff00"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road",
    //         "elementType": "all",
    //         "stylers": [
    //           {
    //             "saturation": -100
    //           },
    //           {
    //             "lightness": "48"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.highway",
    //         "elementType": "all",
    //         "stylers": [
    //           {
    //             "visibility": "simplified"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.highway",
    //         "elementType": "geometry",
    //         "stylers": [
    //           {
    //             "visibility": "simplified"
    //           },
    //           {
    //             "color": "#ffffff"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.highway",
    //         "elementType": "labels",
    //         "stylers": [
    //           {
    //             "visibility": "simplified"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.highway",
    //         "elementType": "labels.text.fill",
    //         "stylers": [
    //           {
    //             "color": "#666464"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.highway",
    //         "elementType": "labels.icon",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.arterial",
    //         "elementType": "labels.text.fill",
    //         "stylers": [
    //           {
    //             "color": "#4d4d4d"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.arterial",
    //         "elementType": "labels.icon",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.local",
    //         "elementType": "all",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           },
    //           {
    //             "color": "#acacac"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.local",
    //         "elementType": "geometry",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           },
    //           {
    //             "lightness": "69"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.local",
    //         "elementType": "labels.text.fill",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           },
    //           {
    //             "color": "#393939"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.local",
    //         "elementType": "labels.text.stroke",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.local",
    //         "elementType": "labels.icon",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "transit",
    //         "elementType": "all",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "transit.line",
    //         "elementType": "all",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "transit.line",
    //         "elementType": "geometry",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "transit.line",
    //         "elementType": "labels.text",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "transit.line",
    //         "elementType": "labels.icon",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "water",
    //         "elementType": "all",
    //         "stylers": [
    //           {
    //             "color": "#aad2e3"
    //           },
    //           {
    //             "visibility": "on"
    //           }
    //         ]
    //       }
    //     ]
    //   });
    //   let icon = "/static/favicon.png"
    //   let marker = new google.maps.Marker({
    //     position: {lat: 41.080675, lng: 29.022300},
    //     map: map,
    //     title: 'Sarıkaya Şahin Hukuk',
    //     image: icon
    //   });
    // }
  } });

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact fullHeight"
  }, [_c('div', {
    staticClass: "container fullHeight is-fluid noMargin"
  }, [_c('div', {
    staticClass: "columns fullHeight"
  }, [_c('div', {
    staticClass: "column contactHalf fullHeight"
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column contactBox"
  }, [_c('h1', [_vm._v("CONTACT")]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v(" TELEPHONE ")]), _vm._v(" "), _c('p', [_vm._v("+90 533 424 85 00 - +90 533 425 85 00")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v(" FAX ")]), _vm._v(" "), _c('p', [_vm._v("+90 212 385 00 05")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v(" E-MAIL ")]), _vm._v(" "), _c('p', [_vm._v("info@sarikayasahin.com")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v(" ADDRESS ")]), _vm._v(" "), _c('p', [_vm._v("Balmumcu Mah. Zincirlikuyu Yolu Sok. No: 5/1, Besiktas, Istanbul")])])])])])])])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(142),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-09966a3f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'privacyPolicy',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacyPolicy"
  }, [_c('div', {
    staticClass: "section is-medium"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("PRIVACY POLICY")])]), _vm._v(" "), _c('div', {
    staticClass: "column tile is-parent is-vertical is-6"
  }, [_c('span', {}, [_c('ul', [_c('small', [_vm._v("August 28, 2017")]), _vm._v(" "), _c('p', [_vm._v("This policy (“Policy”) sets out the Sarıkaya + Şahin’s privacy policy implemented in sarikayasahin.com (“Website”). By entering the Website, you acknowledge and accept this Policy.")]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Which information do we collect?")])]), _vm._v(" "), _c('li', [_vm._v("We do not collect your personally identifiable information throughout the Website but we collect the domain names and IP addresses of the visitors, along with usage statistics (e.g., types of web browsers and operating systems used). This data is used to more efficiently operate the Website. We may combine this information with the personally identifiable and other information we have.")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("We also collect any information you may choose to provide in your communications with us. Please do not send us any confidential information until we have confirmed in writing that we represent or act for you. Unsolicited emails from non-clients do not establish a lawyer-client relationship, may not be privileged, and may be disclosed to others.")]), _c('br')]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("How do we use your information?")])]), _c('br'), _vm._v(" "), _c('li'), _c('li', [_vm._v("We may use your information:")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("i. to process and respond to inquiries;")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("ii. for the purposes for which you provided the information;")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("iii. to improve the content and navigability of the Website;")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("iv. to inform you regarding new features, special events, and service offerings.")]), _c('br')]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("How do we protect your information?")])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("We aim to protect your information against the loss, misuse and alteration. We spend our utmost afford to implement reasonable administrative, technical and physical measures to protect your personal information.")]), _c('br')]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("Do we share your information with third parties?")])]), _c('li'), _c('br'), _vm._v(" "), _c('li', [_vm._v("If you would seek legal assistance from us for an issue other than our expertise areas or a non-Turkish law advice, your information might be shared with our business partners in Turkey and in other countries, including the United States.")]), _c('br')]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("How do we apply changes to the Policy?")])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("From time to time, we may change this Policy. Changes to this Policy are effective as of the date listed above and indicates the last time this Policy was amended or materially changed.  Your continued use of the Website indicates your consent to the changes to this Policy. If you object to any changes to this Policy, please contact us or stop using the Website.")]), _c('br')]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("Contact Us")])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Sarıkaya + Şahin")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("E. info@sarikayasahin.com")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("T. +90 533 424 85 00 - +90 533 425 85 00")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("F. +90 212 385 00 05")]), _c('br')])])])])])])])
}]}

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(144)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(146),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5089a07a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cookie-policy',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cookiePolicy"
  }, [_c('div', {
    staticClass: "section is-medium"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("COOKIE POLICY")])]), _vm._v(" "), _c('div', {
    staticClass: "column tile is-parent is-vertical is-6"
  }, [_c('span', {}, [_c('span', {}, [_c('ul', [_c('p', [_vm._v("This policy (“Policy”) sets out the use of the cookies and similar technologies on www.sarikayasahin.com (“Website”). In order to make the Website work properly, Sarıkaya + Şahin, place small data files called cookies on your device.")]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v("What are cookies?")])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("A cookie is a small text file that a website saves on your computer or mobile device when you visit the site. It enables the website to remember your actions and preferences (such as login, language, font size and other display preferences) over a period of time, so you do not have to keep re-entering them whenever you come back to the site or browse from one page to another.")]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v("How do we use cookies?")])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("We use session and persistent cookies on this site. A session ID cookie expires when you close your browser. A persistent cookie remains on your hard drive for an extended period of time. You can remove persistent cookies and reject persistent and session cookies by following the directions provided in your internet browser’s “help” file or by visiting www.aboutcookies.org or www.allboutcookies.org . If you reject persistent or session cookies, you may still use the Website, but you may not be able to access all the Website’s functionality or your access may be limited.")]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v("We use cookies to:")])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("remember choices you have made and personalise your use of the site. This includes that cookies:\n                  "), _c('ul', {
    staticClass: "listPadding"
  }, [_c('li', [_vm._v("a.​ remember and recognise you on subsequent visits to the site,")]), _vm._v(" "), _c('li', [_vm._v("b.​ identify how you use this site, including tracking how you use the site, such as information on where you came from, what content you viewed on the site, and the duration of your visit.")])])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("We do not collect personally identifiable information about your online activities over time and across third party websites or online services. Our third party business partners do not collect personally identifiable information about your online activities over time and across third party websites or online services through your use of the Website.")]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v("How to control cookies?")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_vm._v("You can control and/or delete cookies as you wish – for details, see www.aboutcookies.org or www.allboutcookies.org . You can delete all cookies that are already on your computer and you can set most browsers to prevent them from being placed. If you do this, however, you may have to manually adjust some preferences every time you visit a site and some services and functionalities may not work.")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Please see below for the information on how to delete cookies at each web browser:")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Safari")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("1. Go to the Safari menu.")]), _vm._v(" "), _c('li', [_vm._v("2. Click on the Preferences.")]), _vm._v(" "), _c('li', [_vm._v("3. Click the ‘Security’ tab.")]), _vm._v(" "), _c('li', [_vm._v("4. Under ‘Accept Cookies’, set it to accept, reject, or selectively accept cookies.")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Firefox 3.0+")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("1. Click on 'Tools' in the menu bar")]), _vm._v(" "), _c('li', [_vm._v("2. Click on 'Options...' ")]), _vm._v(" "), _c('li', [_vm._v("3. Click on 'Privacy’ Tab in the top section")]), _vm._v(" "), _c('li', [_vm._v("4. From the drop down box select ‘Use custom setting for history’")]), _vm._v(" "), _c('li', [_vm._v("5. Un -tick the box that says 'Accept Cookies From sites'")]), _vm._v(" "), _c('li', [_vm._v("6. Click OK and Close the screen.")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Internet Explorer 7.0+")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("1. Click on 'Tools' in the menu bar")]), _vm._v(" "), _c('li', [_vm._v("2. Click on 'Options'")]), _vm._v(" "), _c('li', [_vm._v("3. Click on 'Privacy' Tab on top section")]), _vm._v(" "), _c('li', [_vm._v("4. Click on the 'Advanced\" button")]), _vm._v(" "), _c('li', [_vm._v("5. Select ‘Prompt’ for both ‘First party cookies’ and ‘Third Party Cookies’")]), _vm._v(" "), _c('li', [_vm._v("6. Click OK and Close the screen.")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Google Chrome 8.0+")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("1. Click to 'Tools Menu'")]), _vm._v(" "), _c('li', [_vm._v("2. Click on 'Options'")]), _vm._v(" "), _c('li', [_vm._v("3. Click on 'Under the Bonnet'")]), _vm._v(" "), _c('li', [_vm._v("4. Click on 'Cookie Setting' button and tick ‘Block all third-party cookies without exception’")]), _vm._v(" "), _c('li', [_vm._v("5. Close the screen.")]), _c('br')]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("Contact Us")])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Sarıkaya + Şahin")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("E. info@sarikayasahin.com")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("T. +90 533 424 85 00 - +90 533 425 85 00")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("F. +90 212 385 00 05")]), _c('br')])])])])])])])])
}]}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(148)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b35942e2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'legal-notices',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legalNotices"
  }, [_c('div', {
    staticClass: "section is-medium"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("LEGAL NOTICES")])]), _vm._v(" "), _c('div', {
    staticClass: "column tile is-parent is-vertical is-8"
  }, [_c('span', {}, [_c('ul', [_c('li', [_c('p', [_vm._v("This website sarikayasahin.com (“Website”) is designed for general information only. Its contents aim to comply with the Professional Rules and the Regulation on Prohibition of Advertising published by the Turkish Bar Association.\n                ")])]), _c('br'), _vm._v(" "), _c('li', [_c('p', [_vm._v("The information herein should not be construed as legal advice or formation of a lawyer/client relationship. The information is not guaranteed to be correct, complete, or up-to-date. Sarıkaya + Şahin makes no warranty regarding the accuracy or reliability of the information at this Website.\n                ")])]), _c('br'), _vm._v(" "), _c('li', [_c('p', [_vm._v("The Website and its content are the sole and exclusive property of Sarıkaya + Şahin. You agree not to reproduce, duplicate, copy, sell, resell or exploit for any commercial purpose, any portion of the Website or its content other than as expressly authorized by Sarıkaya + Şahin in writing. You hereby acknowledge and agree that all right, title, and interest in and to the Website and the content shall be owned exclusively by Sarıkaya + Şahin. Use of the Website or its content in any way not expressly permitted is prohibited.\n                ")])]), _c('br'), _vm._v(" "), _c('li', [_c('p', [_vm._v("The Website is protected by Law no:5846 on Intellectual and Artistic Works in Turkey and by treaties, copyright laws and regulations internationally. You may not modify, reproduce or distribute the content, design or layout of the Website, or individual sections of the content, design or layout of the Website, without Sarıkaya + Şahin’s express prior written permission.\n                ")])]), _c('br')])])])])])])])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(152)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(154),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'turkish',
  props: {},
  data: function data() {
    return {};
  },

  methods: {},
  computed: {}
});

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tr; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_homepage_tr__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_homepage_tr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_homepage_tr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_hakkimizda__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_hakkimizda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_hakkimizda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_faaliyet__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_faaliyet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_faaliyet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_ekip__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_ekip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_ekip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_yayinlar__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_yayinlar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_yayinlar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_iletisim__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_iletisim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_iletisim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_gizlilik__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_gizlilik___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_gizlilik__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_cerez_politikasi__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_cerez_politikasi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_cerez_politikasi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_yasal_bildirimler__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_yasal_bildirimler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_yasal_bildirimler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_bulten__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_bulten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_bulten__);











var tr = [{
  path: '',
  name: 'homepage-tr',
  component: __WEBPACK_IMPORTED_MODULE_0__views_homepage_tr___default.a,
  meta: {
    policy: true,
    tur: true
  }
}, {
  path: 'hakkimizda',
  name: 'hakkimizda',
  component: __WEBPACK_IMPORTED_MODULE_1__views_hakkimizda___default.a,
  meta: {
    tur: true
  }
}, {
  path: 'hukuk-faaliyet-alanlari',
  name: 'faaliyet',
  component: __WEBPACK_IMPORTED_MODULE_2__views_faaliyet___default.a,
  meta: {
    tur: true
  }
}, {
  path: 'ekibimiz',
  name: 'ekip',
  component: __WEBPACK_IMPORTED_MODULE_3__views_ekip___default.a,
  meta: {
    tur: true
  }
},, {
  path: 'bulten',
  name: 'bulten',
  component: __WEBPACK_IMPORTED_MODULE_9__views_bulten___default.a,
  meta: {
    tur: true
  }
}, {
  path: 'yayinlar',
  name: 'yayinlar',
  component: __WEBPACK_IMPORTED_MODULE_4__views_yayinlar___default.a,
  meta: {
    tur: true
  }
}, {
  path: 'iletisim',
  name: 'iletisim',
  component: __WEBPACK_IMPORTED_MODULE_5__views_iletisim___default.a,
  meta: {
    tur: true
  }
}, {
  path: 'gizlilik-politikasi',
  name: 'gizlilik',
  component: __WEBPACK_IMPORTED_MODULE_6__views_gizlilik___default.a,
  meta: {
    tur: true
  }
}, {
  path: 'cerez-politikasi',
  name: 'cerez-politikasi',
  component: __WEBPACK_IMPORTED_MODULE_7__views_cerez_politikasi___default.a,
  meta: {
    tur: true
  }
}, {
  path: 'yasal-bildirimler',
  name: 'yasal-bildirimler',
  component: __WEBPACK_IMPORTED_MODULE_8__views_yasal_bildirimler___default.a,
  meta: {
    tur: true
  }
}];

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(157)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7eb3d340",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_videoBg_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_videoBg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_videoBg_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    videoBg: __WEBPACK_IMPORTED_MODULE_0__components_videoBg_vue___default.a
  },
  name: 'hptr',
  data: function data() {
    return {};
  },

  // mounted() {
  //     if (this.$root._route.meta.policy) {
  //       this.policy = true
  //       console.log('DENEMEDİR')
  //   } else {
  //       this.policy = false
  //   }
  // },
  computed: {}
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "griddy-contain"
  }, [_vm._m(0), _vm._v(" "), _c('videoBg')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "griddy container is-flui"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-hidden-mobile"
  }, [_c('h1', [_vm._v("SARIKAYA\n          "), _c('span', {
    staticClass: "plus"
  }, [_vm._v("+")]), _vm._v(" "), _c('span', {
    staticClass: "s"
  }, [_vm._v("S")]), _vm._v("AH"), _c('span', {
    staticClass: "i"
  }, [_vm._v("I")]), _vm._v("N")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Günümüzde yaşanan teknolojik ve ekonomik değişimlerin etkileri, hukuk alanında da kendini göstermektedir. Bu etkiler, dinamik, açık görüşlü, yenilikleri ve teknolojik gelişmeleri yakından takip eden hukukçulara olan ihtiyacı da beraberinde getirmektedir. Sarıkaya + Şahin, bu ihtiyaca cevap verebilmeyi ve hizmet verdiği alanlarda daha iyiye ulaşmayı temel hedefi olarak belirlemektedir.")]), _vm._v(" "), _c('span', {
    staticClass: "liner"
  })])])])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(163),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79c0b338",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hakkimizda',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "aboutUs"
  }, [_c('div', {
    staticClass: "section is-medium"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("HAKKIMIZDA")])]), _vm._v(" "), _c('div', {
    staticClass: "column tile is-parent is-vertical"
  }, [_c('p', {
    staticClass: "tile is-child"
  }, [_vm._v("Günümüzde yaşanan teknolojik ve ekonomik değişimlerin etkileri, hukuk alanında da kendini göstermektedir. Bu etkiler, dinamik, açık görüşlü, yenilikleri ve teknolojik gelişmeleri yakından takip eden hukukçulara olan ihtiyacı da beraberinde getirmektedir. Sarıkaya + Şahin, bu ihtiyaca cevap verebilmeyi ve hizmet verdiği alanlarda daha iyiye ulaşmayı temel hedefi olarak belirlemektedir. ")]), _vm._v(" "), _c('p', {
    staticClass: "tile is-child"
  }, [_vm._v("Sarıkaya + Şahin, gelişim ve değişimde sürekliliği sağlayarak müvekkillerinin hedeflerine ulaşmaları ve iş stratejilerini gerçekleştirmeleri için çeşitli ticari sektörlerde karşılaştıkları hukuki sorunlarına etkin çözümler sunar.")]), _vm._v(" "), _c('p', {
    staticClass: "tile is-child"
  }, [_vm._v("Sarıkaya + Şahin, hukuki sorunlara olan çözüm odaklı ve kişisel - kurumsal menfaat etkinliğini öne çıkaran yaklaşımları ile müvekkillerine karşı olan sorumluluklarını özenle yerine getirmektedir. Müvekkillerine gelişmekte olan sektörlerde olduğu kadar şirket danışmanlığı ve ticari uyuşmazlıklardaki deneyimleri ile de hukuki hizmet vermektedir.")]), _vm._v(" "), _c('p', {
    staticClass: "tile is-child"
  }, [_vm._v("Sarıkaya + Şahin, idari kurum ve kuruluşlarla ilişkiler, lisans, ruhsatlandırma ve izin prosedürlerinin takibi ve sonuçlandırılması konularında Ankara’da yirmi yılı aşkın süredir faaliyet gösteren Uğur Poyraz Hukuk Bürosu ile iş birliği yaparak; özel kişi girişimcilerden uluslararası yatırımcı ve holdinglere varıncaya kadar her ölçekten şirkete danışmanlık sağlamaktadır.")])])])])])]), _vm._v(" "), _c('span', {
    staticClass: "uplogo"
  }, [_c('img', {
    attrs: {
      "src": "/static/upLogo.png"
    }
  })])])
}]}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(165)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(167),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0601eadc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'practiceAreas',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "practiceAreas"
  }, [_c('div', {
    staticClass: "section is-medium"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("FAALİYET ALANLARI")])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('span', {
    staticClass: "plusActive"
  }), _vm._v(" "), _c('div', {
    staticClass: "tile is-vertical is-12"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child notification "
  }, [_c('ul', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('li', [_vm._v("Fikri ve Sınai Mülkiyet Hukuku")]), _vm._v(" "), _c('li', [_vm._v("Bilgi Teknolojileri, E-Ticaret")]), _vm._v(" "), _c('li', [_vm._v("Alan Adları ve Telekomünikasyon")]), _vm._v(" "), _c('li', [_vm._v("Kişisel Verilerin Korunması")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child notification"
  }, [_c('ul', {
    staticClass: "has-text-right is-parent is-vertical tile"
  }, [_c('li', [_vm._v("Deniz ve Taşıma Hukuku")]), _vm._v(" "), _c('li', [_vm._v("Hava Hukuku")]), _vm._v(" "), _c('li', [_vm._v("Gümrük ve Liman İşletmeleri")]), _vm._v(" "), _c('li', [_vm._v("Yabancıların Çalışma ve İkamet İzinleri")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child notification"
  }, [_c('ul', {
    staticClass: "has-text-left is-parent is-vertical tile"
  }, [_c('li', [_vm._v("Dava Takibi ve Ticari Uyuşmazlıklar")]), _vm._v(" "), _c('li', [_vm._v("Sözleşmeler")]), _vm._v(" "), _c('li', [_vm._v("Gayrimenkul Hukuku")]), _vm._v(" "), _c('li', [_vm._v("İnşaat Hukuku")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child notification"
  }, [_c('ul', {
    staticClass: "has-text-right is-parent is-vertical tile"
  }, [_c('li', [_vm._v("Yeni Girişimler (Start-Up) ve Uluslararası Yatırımlar")]), _vm._v(" "), _c('li', [_vm._v("İzin, Lisans ve Ruhsatlandırma")]), _vm._v(" "), _c('li', [_vm._v("Medya, Eğlence ve Moda Hukuku")]), _vm._v(" "), _c('li', [_vm._v("Spor Hukuku")])])])])])])])])])])])
}]}

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(169)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8f4e5f4c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ekip',
    data: function data() {
        return {
            isActive: false,
            isActive2: false,
            isActive3: false,
            isActive4: false,
            isActive5: false,
            isActive6: false,
            isActive7: false,
            isActive8: false
        };
    },

    methods: {
        toggle: function toggle() {
            this.isActive = !this.isActive;
        },
        toggle2: function toggle2() {
            this.isActive2 = !this.isActive2;
        },
        toggle3: function toggle3() {
            this.isActive3 = !this.isActive3;
        },
        toggle4: function toggle4() {
            this.isActive4 = !this.isActive4;
        },
        toggle5: function toggle5() {
            this.isActive5 = !this.isActive5;
        },
        toggle6: function toggle6() {
            this.isActive6 = !this.isActive6;
        },
        toggle7: function toggle7() {
            this.isActive7 = !this.isActive7;
        },
        toggle8: function toggle8() {
            this.isActive8 = !this.isActive8;
        }
    }
    // mounted () {
    //     x = document.getElementsByClassName('extra');
    //     console.log(x);
    // }
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ourTeam"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-vertical"
  }, [_c('div', {
    staticClass: "tile"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tile columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("Burçak Sercan Sarıkaya")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("sarikaya@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle2
    }
  }, [_vm._v("Onur Şahin")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("sahin@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive2
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle2
    }
  })])])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "tile columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle3
    }
  }, [_vm._v("Ali Rıza Aksoy")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("aksoy@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive3
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle3
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle4
    }
  }, [_vm._v("Halil Çolak")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("colak@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive4
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle4
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle5
    }
  }, [_vm._v("Hüseyin Alp İlker")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("ilker@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive5
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle5
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle7
    }
  }, [_vm._v("Rafet Emin Demir")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("demir@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive7
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle7
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle8
    }
  }, [_vm._v("Uğur Fırtına")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("firtina@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive8
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle8
    }
  })])])])])]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "tile colums"
  }, [_c('div', {
    staticClass: "column is-half paddingless"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle6
    }
  }, [_vm._v("Onur Uraz")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("uraz@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive6
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle6
    }
  })])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-parent is-3 is-vertical"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("EKİBİMİZ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-child  has-text-right is-size-1"
  }, [_c('h2', [_vm._v("KURUCU ORTAKLAR")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/burcakSarikaya.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Burçak Sercan Sarıkaya")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("EĞİTİM")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Atılım Üniversitesi Sosyal Bilimler Enstitüsü (İşletme Doktora Programı – Tam Burslu, devam etmekte)\n                                                                        ")]), _vm._v(" "), _c('li', [_vm._v("Bahçeşehir Üniversitesi Sosyal Bilimler Enstitüsü (Özel Hukuk Tezli Yüksek Lisans Programı – Tam Burslu)\n                                                                        ")]), _vm._v(" "), _c('li', [_vm._v("Ankara Üniversitesi Hukuk Fakültesi (Lisans) ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("ÜYELİKLER")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("ELSA")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("YABANCI DİL")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("İngilizce")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/onurSahin.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Onur Şahin")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("EĞİTİM")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Galatasaray Üniversitesi Sosyal Bilimler Enstitüsü (Özel Hukuk Doktora Programı, devam etmekte)\n                                                                        ")]), _vm._v(" "), _c('li', [_vm._v("Galatasaray Üniversitesi Sosyal Bilimler Enstitüsü (Özel Hukuk Tezli Yüksek Lisans Programı)\n                                                                        ")]), _vm._v(" "), _c('li', [_vm._v("\n                                                                            Glasgow Üniversitesi Hukuk Fakültesi (Fikri Mülkiyet ve Dijital Ekonomi Tezli Yüksek Lisans Programı – Avrupa Birliği Jean Monnet Bursu ile)\n                                                                        ")]), _vm._v(" "), _c('li', [_vm._v("Ankara Üniversitesi Hukuk Fakültesi (Lisans) ")]), _vm._v(" "), _c('li', [_vm._v("Passau Üniversitesi Hukuk Fakültesi ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("ÜYELİKLER")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Marka Vekili ")]), _vm._v(" "), _c('li', [_vm._v("Patent Vekili ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Yabancı Dil")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("İngilizce")]), _vm._v(" "), _c('li', [_vm._v("Almanca")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-child  has-text-right is-size-1"
  }, [_c('h2', [_vm._v("AVUKATLAR")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/aliRiza.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Ali Rıza Aksoy")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("EĞİTİM")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Ankara Üniversitesi Hukuk Fakültesi (Lisans)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("ÜYELİKLER")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("ELSA")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("YABANCI DİL")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("İngilizce ")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/halil.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Halil Çolak")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("EĞİTİM")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Ankara Üniversitesi Hukuk Fakültesi (Lisans)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("YABANCI DİL")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("İngilizce")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/alp.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Hüseyin Alp İlker")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("EĞİTİM")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Galatasaray Üniversitesi Sosyal Bilimler Enstitüsü (Özel Hukuk Tezli Yüksek Lisans Programı) ")]), _vm._v(" "), _c('li', [_vm._v("Ankara Üniversitesi Hukuk Fakültesi (Lisans) ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("YABANCI DİL")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("İngilizce")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/rafet.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Rafet Emin Demir")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("EĞİTİM")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Galatasaray Üniversitesi Sosyal Bilimler Enstitüsü (Özel Hukuk Tezli Yüksek Lisans Programı) ")]), _vm._v(" "), _c('li', [_vm._v("Ankara Üniversitesi Hukuk Fakültesi (Lisans) ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("YABANCI DİL")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("İngilizce")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/ugur.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Uğur Fırtına ")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("EĞİTİM")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Ankara Üniversitesi Hukuk Fakültesi (Lisans) ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("YABANCI DİL")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("İngilizce")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-child  has-text-right is-size-1"
  }, [_c('h2', [_vm._v("DANIŞMAN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/onur.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Onur Uraz")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("EĞİTİM")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Southampton Üniversitesi (Uluslararası Ceza Hukuku Doktora Programı)")]), _vm._v(" "), _c('li', [_vm._v("Glasgow Üniversitesi (Ululararası Kamu Hukuku Yüksek Lisans Programı)")]), _vm._v(" "), _c('li', [_vm._v("Gazi Üniversitesi Hukuk Fakültesi (Lisans)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("ÜYELİKLER")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Southampton Student Law Review Editörü (2017)")]), _vm._v(" "), _c('li', [_vm._v("Ankara Barosu Dergisi Yürütme Kurulu Üyesi (2012)")]), _vm._v(" "), _c('li', [_vm._v("International Association of Genocide Scholars ")]), _vm._v(" "), _c('li', [_vm._v("European Society of International Law")]), _vm._v(" "), _c('li', [_vm._v("The Centre for Law, Policy and Society (Southampton University)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("YABANCI DİL")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("İngilizce")])])])])])])])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(173)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(175),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a08eb14",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'yayinlarimiz',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publications"
  }, [_c('div', {
    staticClass: "section is-medium"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column tile is-parent is-vertical is-6"
  }, [_c('span', {}, [_c('ul', [_c('H3', [_vm._v("YAYINLAR")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Profesyonel Futbolcu Sözleşmelerİnİn Sona Ermesİ ve Bunlardan Kaynaklanan Uyuşmazlıkların Sportİf Yargı Yoluyla Çözümlenmesİ\n              ")]), _c('br'), _vm._v(" "), _vm._m(1), _c('br'), _vm._v(" "), _vm._m(2), _c('br'), _vm._v(" "), _vm._m(3), _c('br'), _vm._v(" "), _vm._m(4), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("CISG Kapsamında Alıcının Zararı Azaltma Külfetİ")]), _c('br'), _vm._v(" "), _vm._m(5), _c('br'), _vm._v(" "), _vm._m(6), _c('br'), _vm._v(" "), _vm._m(7), _c('br'), _vm._v(" "), _vm._m(8), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Kefalet ve Bağımsız Garantİ Sözleşmelerİnİn Sona Erme Hallerİ")]), _c('br'), _vm._v(" "), _vm._m(9), _c('br'), _vm._v(" "), _vm._m(10), _c('br'), _vm._v(" "), _vm._m(11), _c('br'), _vm._v(" "), _vm._m(12), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("The Past, the Present and the Future of Colour and Smell Marks (RENK VE KOKU MARKALARININ GEÇMİŞİ, MEVCUT DURUMU VE GELECEĞİ)")]), _c('br'), _vm._v(" "), _vm._m(13), _c('br'), _vm._v(" "), _vm._m(14), _c('br'), _vm._v(" "), _vm._m(15), _c('br'), _vm._v(" "), _vm._m(16), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Should Copyright Law Protect Advertising Slogans? (REKLAM SLOGANLARI TELİF HUKUKU KAPSAMINDA KORUNMALI MIDIR?)")]), _c('br'), _vm._v(" "), _vm._m(17), _c('br'), _vm._v(" "), _vm._m(18), _c('br'), _vm._v(" "), _vm._m(19), _c('br'), _vm._v(" "), _vm._m(20), _c('br')], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("TV Formatlarının Kopyalanması: Telİf Haklarına Aykırılık Eşİğİnİn Saptanması Sorunu")]), _c('br'), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('small', [_vm._v("İdare Hukukunda Yetkİ Sözleşmelerİ")]), _c('br'), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('ul', [_c('H3', [_vm._v("SEMİNERLER")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("İstanbul Barosu ve İstanbul Bİlgİ Ünİversİtesİ tarafından organİze edİlen Denİz İcra Hukukunda Güncel Sorunları İsİmlİ semİner.")]), _c('br'), _vm._v(" "), _vm._m(23), _c('br'), _vm._v(" "), _vm._m(24), _c('br')], 1), _vm._v(" "), _c('ul', [_c('H3', [_vm._v("BASINDA")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Yabancı Bayraklı Yatların Türk Bayrağına Geçişi İçin Getirilen Mevzuatın Avantajları ve Dezavantajları ")]), _c('br'), _vm._v(" "), _vm._m(25), _c('br'), _vm._v(" "), _vm._m(26), _c('br'), _vm._v(" "), _vm._m(27), _c('br')], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("YAYINLAR")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Yayınlanma Tarihi")]), _vm._v(" : 16 Aralık 2016")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Yayıncı")]), _vm._v(" : On İki Levha Yayıncılık A. Ş.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Link")]), _vm._v(" : "), _c('a', {
    attrs: {
      "href": "http://www.onikilevha.com/yazar_detay.php?yazarid=504"
    }
  }, [_vm._v("http://www.onikilevha.com/yazar_detay.php?yazarid=504")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Özet :")]), _vm._v(" Profesyonel futbolcu sözleşmesi, profesyonel futbolun merkezinde yer alan, futbolcu ve kulüp arasındaki hukuki ilişkiyi düzenleyen sözleşmedir. Futbolun dışa kapalı yapısından dolayı sözleşme, ilişkinin devamından daha çok sona erme sırasında yargısal incelemeden geçmektedir. Sona ermenin ortaya çıkardığı hukuki sonuçlar, taraflar arasında uyuşmazlık konusu haline gelebilmektedir. Profesyonel futbolcu sözleşmesinin sona ermesinden kaynaklanan uyuşmazlıkların çözümü için taraflar, devlet yargısına başvurabilecekleri gibi sportif yargı yoluna da başvurma hakkına sahiptir. Sportif yargı yolunda, devlet yargısına kıyasla, sportif uyuşmazlıklar konusunda uzmanlardan oluşan kişi ve heyetlerce, spora özgü niteliklerin göz önüne alınarak çabuk ve pratik yargılama yapılmasından dolayı uyuşmazlıklar, daha etkili olarak çözülmektedir. Bu noktada, ülkemizde TFF bünyesinde yer alan, futbol dalında görevli sportif yargı ve FIFA ve CAS bünyesinde yer alan uluslararası sportif yargının benzer ve farklı yönlerinin incelenmesi gerekmektedir. Tüm bu sebeplerle çalışmamız, profesyonel futbolcu sözleşmesinin nasıl sona erdiğini, bu durumda ne gibi sonuçlar ve uyuşmazlıkların çıktığını, uyuşmazlıkların ulusal ve uluslararası sportif yargı yoluyla nasıl çözümlendiğini incelemeyi amaçlamaktadır.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Yayın Tarihi ")]), _vm._v(" : 29 Aralık 2016")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Yayınlandığı Yer")]), _vm._v("  : Galatasaray Üniversitesi Hukuk Fakültesi Dergisi 2016 - 2")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Link")]), _vm._v("  : "), _c('a', {
    attrs: {
      "href": "http://dosya.gsu.edu.tr/Sayfalar/2017/1/gsuhfd_2016_2son-663.pdf"
    }
  }, [_vm._v("http://dosya.gsu.edu.tr/Sayfalar/2017/1/gsuhfd_2016_2son-663.pdf")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Özet :")]), _vm._v(" Uluslararası Mal Satım Sözleşmelerine İlişkin Birleşmiş Milletler Antlaşması (CISG) kapsamında, hem alıcı hem de satıcı zararı azaltma külfeti altındadır. Ancak uygulamada çoğunlukla alıcının zarara uğradığı ve dolayısıyla alıcının zararı azaltma külfeti altında bulunduğu görülmektedir. Zararı azaltma külfeti kapsamında, alıcı, ihlalden doğan zararları azaltmak için bütün makul önlemleri almak zorundadır. Aksi takdirde, zararın azaltılabilecek olduğu miktarda tazminat hakkını yitirmektedir. Teoride net olan zararı azaltma külfeti, uygulamada kimi belirsizliklere yol açabilmektedir. Külfetin hangi koşullarda, nasıl ve ne ölçüde önlemler almayı gerektirdiği gerek sözleşme taraflarınca gerekse mahkeme ve tahkim kurullarınca çok kolay saptanamamaktadır.\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Yayın Tarihi")]), _vm._v(" : 1 Eylül 2016")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Yayınlandığı Yer")]), _vm._v(" : Türkiye Barolar Birliği Dergisi 126, 311-338.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Link")]), _vm._v("  : "), _c('a', {
    attrs: {
      "href": "http://tbbdergisi.barobirlik.org.tr/m2016-126-1605"
    }
  }, [_vm._v("http://tbbdergisi.barobirlik.org.tr/m2016-126-1605")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Özet :")]), _vm._v(" Kişisel teminat sözleşmelerinden en yaygın olarak kullanılan kefalet sözleşmeleri ve bağımsız garanti sözleşmeleri, kimi benzerlikler taşımanın yanı sıra, sona erme halleri bakımından önemli farklılıklar barındırmaktadır. Sona erme hallerinin önemli farklılıklar göstermesinin en başta gelen sebebi, garanti sözleşmesinin temelde yer alan sözleşmeden bağımsız olmasına rağmen kefalet sözleşmesinin fer’i niteliğe sahip olmasıdır. Buna ilaveten, kefalet sözleşmesinin sona erme halleri kanunda düzenlenmişken garanti sözleşmesinin sona ermesine ilişkin kanunda herhangi bir düzenleme yer almamaktadır. ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Yayın Tarihi")]), _vm._v(" : 1 Ağustos 2016")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Yayınlandığı Yer")]), _vm._v(" : European Intellectual Property Review 38(8), 504-516 ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Link")]), _vm._v(" : "), _c('a', {
    attrs: {
      "href": "https://hslib.sinica.edu.tw/sites/default/files/LW29_38-8.pdf"
    }
  }, [_vm._v("https://hslib.sinica.edu.tw/sites/default/files/LW29_38-8.pdf")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Özet :")]), _vm._v(" Geleneksel olmayan markalar, uzun süredir ticaret ve reklam faaliyetlerinde kullanılmasına rağmen mevcut AB marka hukuku sisteminde kendine yer bulmakta zorlanmaktadır.  Bu problem, mevcut sistemin kelimeler, isimler ve logolar gibi geleneksel markaların baz alınarak kurulmasından kaynaklanmaktadır. "), _c('br'), _vm._v("\n\n                                        İşbu teze, geleneksel olmayan markalardan özellikle renk, ses ve koku markaları konu edilmiş ve bu markaların hangi şartlar altında AB hukuku dahilinde kaydedilebilir olabileceğini incelenmiştir. Bu bağlamda, markaların kaydedilebilirliği karşısında iki önemli engel bulunmaktadır, bunlar markaların grafiksel olarak gösterimi gerekliliği ve ayırt edici nitelik taşıma gerekliliğidir. Öncelikle, görsel olmayan işaretlerin grafiksel olarak gösterilmesi kendi içinde büyük bir engel ve çelişki oluşturmaktadır. Bu noktada içtihat hukuku, her ne kadar renk ve seslerin görsel olarak ifade edilmesinde kimi yöntemleri geçerli saysa da, genel olarak bakıldığında kapsamdı bir rehberlik sağlamakta yetersiz kaldığı görülmektedir. Özellikle koku markalarının kaydedilebilirliği teorik olarak serbest olsa da pratikte şu ana kadar, kokuların grafiksel gösterimi ile ilgili denenmiş hiçbir yöntem yeterli görülmemiştir. Ayırt edici nitelik taşıma gerekliliği, her ne kadar grafiksel gösterim gerekliliğinin getirdiği bariz engellerden dolayı gölgede kalsa da geleneksel olmayan markaların ayırt edicilik niteliklerin olup olmadığı da tartışmalıdır. Çünkü birçok geleneksel olmayan işaret hâlihazırda, marka hukuku kapsamı haricinde, yaygın olarak kullanılmakta ve bu durum markaların esas fonksiyonu olan orjin fonksiyonunu zedeleyici niteliktedir.\n                                        Geleneksel olmayan markaların kaydedilebilirliğindeki sorunlar, AB Komisyonu’nu mevcut marka hukuku sistemini gözden geçirmeye zorlamakta ve bunun neticesinde yeni birer Marka Direktif ve Düzenlemesi taslağı hazırlanmıştır. Bu taslaklar ile grafiksel gösterim gerekliliğinin kaldırılması ve renk ve seslerin marka oluşturabilecek işaretler olarak kanunda yer alan örneklere dâhil edilmesi amaçlanmaktadır. Ancak grafiksel gösterim gerekliliğini kaldırırken markaların nasıl gösterileceği konusunda netlik sağlamaktan yoksun olması taslakların zayıf noktası olarak nitelenebilir. Bu zayıf nokta, AB marka hukuku sistemi için temel taş olan hukuki belirlilik ilkesinin sağlanamayacağı kuşkularını doğurmaktadır.\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Yayınlandığı Tarih")]), _vm._v(" : 1 Mart 2016")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Yayınlandığı Yer")]), _vm._v(" : European Intellectual Property Review 38, Issue 3, 172-177")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Link")]), _vm._v(" : "), _c('a', {
    attrs: {
      "href": " http://www.sweetandmaxwell.co.uk/Catalogue/ProductDetails.aspx?recordid=460"
    }
  }, [_vm._v(" http://www.sweetandmaxwell.co.uk/Catalogue/ProductDetails.aspx?recordid=460")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Özet :")]), _vm._v(" Reklamlar, her ne kadar ticari amaçlarla meydana getirilmekte ise de, yaratım süreçlerinde fikri emek ve çabanın olduğu gerçeği inkar edilemez. Reklam üst başlığı altında yer alan önemli bir kol olan reklam sloganlarında ise bu fikri çabanın nasıl ve hangi alanda koruma altına alınacağı konusunda soru işaretleri ortaya çıkabilmektedir. Bazı reklam sloganları marka olarak tescil edilmeleri halinde marka hukuku altında korunmakta iken bu makale de reklam sloganlarının telif hakları şemsiyesi altında korunup korunamayacağı tartışılmaktadır. Reklam sloganları, çok kısa olmaları nedeniyle diğer ilim ve edebiyat eserlerinden farklılık taşımaktadır. Ancak bunun yanında, bir cümle veya birkaç kelime ile yoğun şekilde duygu ve fikir aktarma fonksiyonu gösteren reklam sloganları da bulunmaktadır. Bu makalede, reklam sloganlarına telif hakkı koruması tanınması yönünde ve bunun aleyhine olan görüşler karşılıklı olarak ele alınarak tartışılmaktadır.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('strong', [_vm._v("Yayın Tarihi")]), _vm._v(" : 30 Nisan 2015")]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Yayıncı")]), _vm._v(" : Gazi Üniversitesi Hukuk Fakültesi Dergisi 19, Sayı 2, 137-148.")]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Link")]), _vm._v(" : "), _c('a', {
    attrs: {
      "href": "http://webftp.gazi.edu.tr/hukuk/dergi/19_2_4.pdf"
    }
  }, [_vm._v("http://webftp.gazi.edu.tr/hukuk/dergi/19_2_4.pdf")])]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Özet :")]), _vm._v(" TV formatları, sadece ülkemizde değil bütün dünyada çok popüler olan ve gün geçtikçe daha çok izlenen şovlardır. Popülerliklerinden dolayı formatların hakları çoğu ülkeye pazarlanmakta ve oluşturduğu bu pazarın hacmi günümüzde medya sektörüne yön verebilecek büyüklüktedir. Tüm bu nedenlerden dolayı, TV formatları, medya sektöründe hukuken koruma altına alınmak istenen önemli mal varlığı kalemlerindendir. Bu noktada akla ilk gelebilecek alan olan telif hukuku mevcut düzenlemeleriyle, TV formatlarına koruma sağlamada önemli bir engel getirmektedir çünkü formatlar, fikir ve konseptlerin bir araya getirilmesiyle oluşturulmaktadır. Ancak tabi ki, TV formatları, telif hukukunun koruma alanının tamamen dışında değildir yalnızca bir formatının bu alana girip girmediği çok hassas bir değerlendirme ile saptanabilir.\n              ")]), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('strong', [_vm._v("Yayın Tarihi")]), _vm._v(" : Kasım 2009")]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Yayıncı")]), _vm._v(" : Gazi Üniversitesi Hukuk Fakültesi Dergisi 19, Sayı 2, 137-148.")]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Link")]), _vm._v(" : "), _c('a', {
    attrs: {
      "href": "http://webftp.gazi.edu.tr/hukuk/dergi/19_2_4.pdf"
    }
  }, [_vm._v("http://webftp.gazi.edu.tr/hukuk/dergi/19_2_4.pdf")])]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Özet :")]), _vm._v(" Özel hukuk alanında, yetki sözleşmeleri yapmakta taraflara bazı haklar tanınmış olmakla birlikte kamu hukuku alanında yer alan idare hukukunda böyle bir hakkın tanınıp tanınmadığı bu yazının konusunu oluşturmaktadır. Kuşkusuz, ihale süreci sözleşme yapılıncaya kadar idare hukuku alanına girmektedir. Bu süreç içerisinde, idari şartnameler ve sözleşme tasarısında yetkili mahkeme ilişkin hükümler de yer alabilmektedir. Böylesi durumlarda, davanın açıldığı mahkeme, kimi zaman söz konusu hükümlere dayanarak kimi zaman da yetki sözleşmelerine dayanarak dava dosyasını yetkili olduğu ileri sürülen mahkemeye tevdi etmektedir. Konu, genel olarak yetki konusu hakkında temel açıklamalarda bulunduktan sonra idare hukukunda yetki ve idare hukuku alanında yetki sözleşmesi yapılıp yapılamayacağı başlıkları altında tartışılmaktadır.\n\n              ")]), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Tarih")]), _vm._v(" : 13 Mayıs 2017")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Link")]), _vm._v(" : "), _c('a', {
    attrs: {
      "href": "http://www.istanbulbarosu.org.tr/HaberDetay.aspx?ID=12440"
    }
  }, [_vm._v("http://www.istanbulbarosu.org.tr/HaberDetay.aspx?ID=12440")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Yayın Tarihi")]), _vm._v(" : Nisan 2017")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Yayıncı")]), _vm._v(" PARA – Haftalık Ekonomi Dergisi")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Link")]), _vm._v(" : "), _c('a', {
    attrs: {
      "href": "http://www.bluesyachting.com/images/basinda/para_haber_02.pdf"
    }
  }, [_vm._v("http://www.bluesyachting.com/images/basinda/para_haber_02.pdf")])])
}]}

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(177)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(179),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-93878026",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'iletisim',
  data: function data() {
    return {};
  },

  mounted: function mounted() {
    var locate = null;
    if (window.innerWidth > 500 ? locate = { lat: 41.0620881, lng: 29.0098528 } : locate = { lat: 41.0805581, lng: 29.0217118 }) ;
    var map = new google.maps.Map(document.getElementById('map'), {
      center: locate,
      zoom: 15,
      styles: [{
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#444444"
        }]
      }, {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [{
          "color": "#f2f2f2"
        }]
      }, {
        "featureType": "landscape.man_made",
        "elementType": "geometry.stroke",
        "stylers": [{
          "visibility": "simplified"
        }, {
          "color": "#f70000"
        }]
      }, {
        "featureType": "landscape.natural.landcover",
        "elementType": "all",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "featureType": "landscape.natural.terrain",
        "elementType": "geometry",
        "stylers": [{
          "visibility": "on"
        }]
      }, {
        "featureType": "landscape.natural.terrain",
        "elementType": "labels.text",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "featureType": "landscape.natural.terrain",
        "elementType": "labels.icon",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "featureType": "poi.attraction",
        "elementType": "labels.icon",
        "stylers": [{
          "visibility": "on"
        }]
      }, {
        "featureType": "poi.park",
        "elementType": "geometry.fill",
        "stylers": [{
          "visibility": "on"
        }, {
          "color": "#a9f07e"
        }]
      }, {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [{
          "visibility": "on"
        }]
      }, {
        "featureType": "poi.park",
        "elementType": "labels.icon",
        "stylers": [{
          "visibility": "on"
        }, {
          "hue": "#2dff00"
        }]
      }, {
        "featureType": "road",
        "elementType": "all",
        "stylers": [{
          "saturation": -100
        }, {
          "lightness": "48"
        }]
      }, {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [{
          "visibility": "simplified"
        }]
      }, {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [{
          "visibility": "simplified"
        }, {
          "color": "#ffffff"
        }]
      }, {
        "featureType": "road.highway",
        "elementType": "labels",
        "stylers": [{
          "visibility": "simplified"
        }]
      }, {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#666464"
        }]
      }, {
        "featureType": "road.highway",
        "elementType": "labels.icon",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#4d4d4d"
        }]
      }, {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "featureType": "road.local",
        "elementType": "all",
        "stylers": [{
          "visibility": "on"
        }, {
          "color": "#acacac"
        }]
      }, {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [{
          "visibility": "on"
        }, {
          "lightness": "69"
        }]
      }, {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [{
          "visibility": "on"
        }, {
          "color": "#393939"
        }]
      }, {
        "featureType": "road.local",
        "elementType": "labels.text.stroke",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "featureType": "road.local",
        "elementType": "labels.icon",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "featureType": "transit.line",
        "elementType": "all",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [{
          "visibility": "on"
        }]
      }, {
        "featureType": "transit.line",
        "elementType": "labels.text",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "featureType": "transit.line",
        "elementType": "labels.icon",
        "stylers": [{
          "visibility": "on"
        }]
      }, {
        "featureType": "water",
        "elementType": "all",
        "stylers": [{
          "color": "#aad2e3"
        }, {
          "visibility": "on"
        }]
      }]
    });
    var icon = "/static/favicon.png";
    var marker = new google.maps.Marker({
      position: { lat: 41.080675, lng: 29.022300 },
      map: map,
      title: 'Sarıkaya Şahin Hukuk',
      image: icon
    });
  }
});

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact fullHeight"
  }, [_c('div', {
    staticClass: "container fullHeight is-fluid noMargin"
  }, [_c('div', {
    staticClass: "columns fullHeight"
  }, [_c('div', {
    staticClass: "column contactHalf fullHeight"
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column contactBox"
  }, [_c('h1', [_vm._v("İLETİŞİM")]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v(" TELEFON ")]), _vm._v(" "), _c('p', [_vm._v("+90 533 424 85 00 - +90 533 425 85 00")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v(" FAKS ")]), _vm._v(" "), _c('p', [_vm._v("+90 212 385 00 05")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v(" E-POSTA ")]), _vm._v(" "), _c('p', [_vm._v("info@sarikayasahin.com")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v(" ADRES ")]), _vm._v(" "), _c('p', [_vm._v("Balmumcu Mah. Zincirlikuyu Yolu Sok. No: 5/1, Besiktas, Istanbul")])])])])])])])
}]}

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(181)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(183),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44b442b4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'privacyPolicy',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacyPolicy"
  }, [_c('div', {
    staticClass: "section is-medium"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("GİZLİLİK POLİTİKASI\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "column tile is-parent is-vertical is-6"
  }, [_c('span', {}, [_c('ul', [_c('small', [_vm._v("28 Ağustos 2017")]), _vm._v(" "), _c('p', [_vm._v("İşbu politika (“Politika”) www.sarikayasahin.com adresli web sitesinde (“Web Sitesi”) uygulanan gizlilik politikalarını düzenlemektedir. Web Sitesi’ne girerek, Politika’yı kabul ve teyit etmektesiniz.")]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Hangi bilgileri toplamaktayız?")])]), _vm._v(" "), _c('li', [_vm._v("Web Sitesi aracılığıyla Web Sitesi’ni kullanma istatistikleriniz (kullandığınız internet tarayıcıları ve işletim sistemleri gibi) birlikte alan adlarını, IP adreslerini toplamaktayız. Bu veriler, Web Sitesi’nin daha verimli işletilmesi için kullanılmaktadır. Bu bilgileri, toplamış olduğumuz kişisel ve diğer bilgilerle birleştirebiliriz.\n")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Aynı zamanda, bizimle iletişime geçerek paylaşmayı tercih ettiğiniz bilgileri de toplamaktayız. Lütfen sizi temsil ettiğimizi veya sizin adınıza hareket edeceğimizi size yazılı olarak bildirmeden gizli bilgilerinizi bizimle paylaşmayınız. Talebimiz olmaksızın müvekkilimiz olmayan kişi ve kuruluşlardan gelen e-postalar avukat-müvekkil ilişkisi oluşturmaz, gizli tutulmaz veya üçüncü kişilerle paylaşılabilir.")]), _c('br')]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("Bilgilerinizi nasıl kullanıyoruz?")])]), _vm._v(" "), _c('li'), _c('li', [_vm._v("Bilgilerinizi:")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("i. taleplerinizi işlemek ya da yanıtlamak,")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("ii. bilgilerinizi paylaşma amacınız doğrultusunda,")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("iii. web Sitesi’nin içeriğini ve yön bulunabilirliğini geliştirmek,")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("iv. yeni özellikler, özel etkinlikler ve hizmet teklifleri hakkında sizi bilgilendirmek için kullanabiliriz.")]), _c('br')]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("Bilgilerinizi nasıl korumaktayız?")])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Kişisel bilgilerinizin kaybolması, yanlış kullanılması ve değiştirilmesini önlemek amacıyla koruma girişimlerinde bulunur ve kişisel bilgilerinizi korumak için makul ölçüde idari, teknik ve fiziksel önlemler alırız.")]), _c('br')]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("Bilgileriniz üçüncü kişilerle paylaşılabilir mi?")])]), _c('li'), _c('br'), _vm._v(" "), _c('li', [_vm._v("Uzmanlık alanlarımız dışında kalan ve Türk hukukuyla ilgisi olmayan bir konuda bizden hukuki yardım istemeniz durumunda, bilgileriniz Türkiye’deki veya Amerikan Birleşik Devletleri de dâhil olmak üzere diğer ülkelerdeki iş ortaklarımızla paylaşılabilir.")]), _c('br')]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("Politika’da yapılabilecek değişiklikleri nasıl uygularız?")])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Politika’da zaman zaman değişiklikler yapabiliriz.  Politika’da yapılan değişiklikler, yukarıda belirtilmiş olan Politika’nın en son gözden geçirildiği veya önemli ölçüde değiştiği yürürlük tarihinden itibaren geçerlidir. Web Sitesi’ni sürekli kullanımınız Politika’daki değişikliklere onay verdiğinizi göstermektedir. Politika’da yapılan değişikliklere itiraz etmeniz halinde lütfen bizimle iletişime geçiniz veya Web Sitesi’ni kullanmayı durdurunuz.")]), _c('br')]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("İletişim")])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Sarıkaya + Şahin")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("E. info@sarikayasahin.com")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("T. +90 533 424 85 00 - +90 533 425 85 00")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("F. +90 212 385 00 05")]), _c('br')])])])])])])])
}]}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(185)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(187),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-66572732",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cerez-politikasi',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cookiePolicy"
  }, [_c('div', {
    staticClass: "section is-medium"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("ÇEREZ POLİTİKASI")])]), _vm._v(" "), _c('div', {
    staticClass: "column tile is-parent is-vertical is-6"
  }, [_c('span', {}, [_c('span', {}, [_c('ul', [_c('p', [_vm._v("www.sarikayasahin.com adresli web sitesinin (“Web Sitesi”) tam ve düzgün çalışabilmesi için çerez adı verilen küçük veri dosyaları kullanılmaktadır.  İşbu Çerez Politikası (“Politika”), Web Sitesi’ndeki çerezlerin ve benzer teknolojilerin kullanımını düzenlemektedir. ")]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Çerez nedir?")])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Çerezler, web sitelerinin ziyaret edilmesi esnasında kullanıcıların bilgisayarlarına veya mobil cihazlarına yerleştirilen küçük veri depolama dosyalarıdır. Çerezler, web sitesi kullanıcılarının tercihlerini (web sitesi profil adı ve şifresi, dil, yazı büyüklüğü ve diğer görüntüleme tercihleri vb.) hatırlayarak web sitesine her girişte kullanıcıların aynı tercihleri tekrar yapma zorunluluğunu ortadan kaldırmaktadır.")]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Hangi tür çerezleri kullanıyoruz?")])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Web Sitesi’nde oturum çerezleri ve kalıcı çerezler olarak iki farklı türde çerezleri kullanmaktayız. Oturum çerezlerinin kullanımı, tarayıcınızı kapattığınız anda sona ermektedir. Kalıcı çerezler ise, sabit diskinizde uzunca bir süre kalmaktadır. Aşağıda yer verdiğimiz bilgilerle veya internet tarayıcınızın yönlendirmeleriyle veya www.aboutcookies.org ve www.allboutcookies.org sitelerinde yer alan bilgilerle sabit diskinizdeki kalıcı çerezleri kaldırabilir, ayrıca oturum ve kalıcı çerezlerinin kullanımını engelleyebilirsiniz. Ancak kalıcı veya oturum çerezlerinin kullanımını engellemeniz halinde Web Sitesi’ne girişiniz kısıtlı hale gelebilir veya Web Sitesi’nin tüm özelliklerini kullanamayabilirsiniz.\n")]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Hangi amaçlarla çerezleri kullanıyoruz?")])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Çerezleri genel olarak sizi ve yaptığınız tercihleri hatırlamak için ve özel olarak ise aşağıdaki sebeplerle kullanıyoruz:\n                    "), _c('ul', {
    staticClass: "listPadding"
  }, [_c('li', [_vm._v("a.​ Sizi ve tekrar eden Web Sitesi girişlerinizi, Web Sitesi’ni kullanım esnasında yapmış olduğunuz tercihleri hatırlamak,")]), _vm._v(" "), _c('li', [_vm._v("b.​ Web Sitesi’ne nasıl ulaştığınızı, Web Sitesi’ni nasıl kullandığınızı, hangi içerikleri görüntülediğinizi ve ziyaretinizin süresini takip etmek.\n")])])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Üçüncü taraf web siteleri ve servislerindeki çevrimiçi hareketlerinizi takip etmek için çerezleri kullanmadığımızı belirtmek isteriz. Üçüncü taraf iş ortaklarımız da, sizin başka web siteleri ve servislerindeki çevrimiçi hareketlerinizi takip etmek amacıyla çerez kullanmamaktadır.")]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Çerezleri nasıl kontrol edebilirsiniz?")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_vm._v("Cihazlarınızda mevcut bulunan tüm çerezleri silebilir ve/veya çoğu internet tarayıcısında kullanımlarını engelleyebilirsiniz. Ancak bu durumda Web Sitesi’ne her girişinizde tercihlerinizi tekrar tekrar belirlemeniz gerekebilir ve Web Sitesi tam ve doğru olarak çalışmayabilir. Çerezlerin nasıl kullanılacağını kontrol etmek ve/veya cihazlarınızdaki mevcut çerezleri silmek için www.aboutcookies.org ve www.allboutcookies.org sayfalarındaki bilgilerden faydalanabilirsiniz. ")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Aşağıda başlıca internet tarayıcıları üzerinde çerezleri nasıl silebileceğinize ilişkin bilgileri bulabilirsiniz:")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Safari")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("1. Safari menüsüne gidin.")]), _vm._v(" "), _c('li', [_vm._v("2. “Tercihler”e tıklayın.")]), _vm._v(" "), _c('li', [_vm._v("3. “Gizlilik” öğesine tıklayın.")]), _vm._v(" "), _c('li', [_vm._v("4. “Tüm Web Sitesi Verilerini Sil”i veya “Ayrıntılar”ı tıklayın, bir veya daha fazla web sitesi seçin ve “Sil”i tıklayın.")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Firefox")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("1. Menü düğmesine  tıklayın ve “Seçenekler”i seçin.")]), _vm._v(" "), _c('li', [_vm._v("2. “Gizlilik” panelini seçin. ")]), _vm._v(" "), _c('li', [_vm._v("3. ”Firefox uygulaması” ayarını “geçmiş için özel ayarları kullansın” olarak değiştirin.")]), _vm._v(" "), _c('li', [_vm._v("4. “Arama” alanına, Web Sitesi’nin veya çerezlerini silmek istediğiniz sitenin adını yazın. Böylelikle aramanızla eşleşen çerezler görüntülenecektir.")]), _vm._v(" "), _c('li', [_vm._v("5. Silmek istediğiniz çerez(ler)i seçip “Seçilenleri sil” düğmesine tıklayın.")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Internet Explorer 8.0+")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("1. Internet Explorer'da “Güvenlik” düğmesini ve ardından “Gözatma Geçmişini Sil”i seçin.")]), _vm._v(" "), _c('li', [_vm._v("2. “Tanımlama bilgileri”nin yanındaki onay kutusunu işaretleyin.")]), _vm._v(" "), _c('li', [_vm._v("3. “Sık Kullanılanlar” listenizdeki web siteleriyle ilişkili bilgilerini silmek istemiyorsanız “Sık Kullanılanlar web sitesi verilerini koru” onay kutusunu işaretleyin.")]), _vm._v(" "), _c('li', [_vm._v("4. Sil”i seçin.")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Google Chrome 8.0+")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("1. “Ayarlar”'ı tıklayın.")]), _vm._v(" "), _c('li', [_vm._v("2. “Gelişmiş”i tıklayın.")]), _vm._v(" "), _c('li', [_vm._v("3. \"Gizlilik ve güvenlik\"in altında “İçerik ayarları”nı tıklayın.")]), _vm._v(" "), _c('li', [_vm._v("4. “Çerezler”'i tıklayın.")]), _vm._v(" "), _c('li', [_vm._v("5. \"Tüm çerezler ve site verileri\"nin altında Web Sitesi’nin adını arayın.")]), _vm._v(" "), _c('li', [_vm._v("6. Site’nin sağındaki “Kaldır” simgesini tıklayın.")]), _c('br')]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("İletişim")])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Sarıkaya + Şahin")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("E. info@sarikayasahin.com")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("T. +90 533 424 85 00 - +90 533 425 85 00")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("F. +90 212 385 00 05")]), _c('br')])])])])])])])])
}]}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(189)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(191),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42de8059",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'yasal-bildirimler',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legalNotices"
  }, [_c('div', {
    staticClass: "section is-medium"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("YASAL UYARI")])]), _vm._v(" "), _c('div', {
    staticClass: "column tile is-parent is-vertical is-8"
  }, [_c('span', {}, [_c('ul', [_c('li', [_c('p', [_vm._v("Bu web sitesi (“Web Sitesi”), yalnızca genel bilgi sağlamak üzere tasarlanmıştır. İçeriğinin, Türkiye Barolar Birliği tarafından yayımlanan Mesleki Kurallar ve Reklam Yasağı Hakkındaki Yönetmeliği’ne uygun olması amaçlanmıştır.\n                ")])]), _c('br'), _vm._v(" "), _c('li', [_c('p', [_vm._v("Web Sitesi’nde yer alan bilgiler, hukuki görüş verildiği veya avukat/müvekkil ilişkisi oluşturduğu şeklinde yorumlanmamalıdır.\n\n                ")])]), _c('br'), _vm._v(" "), _c('li', [_c('p', [_vm._v("Sunulan bilgilerin doğru, eksiksiz veya güncel olduğu garanti edilmemekte ve Web Sitesi’nde sunulan bilgilerin doğruluğu, eksiksiz oluşu veya güncelliği konusunda herhangi bir taahhütte bulunulmamaktadır. \n                ")])]), _c('br'), _vm._v(" "), _c('li', [_c('p', [_vm._v("Sarıkaya + Şahin, Web Sitesi’nin ve içeriğinin tek ve yegâne sahibidir. Sarıkaya + Şahin’in yazılı olarak açıkça izin verdiği durumlar dışında Web Sitesi’nin veya içeriğin hiçbir kısmını herhangi bir ticari amaç için çoğaltmamayı, kopyalamamayı, satmamayı, tekrar satmamayı veya kendi çıkarınıza kullanmamayı kabul etmektesiniz. Web Sitesi’nde yer alan tüm haklar, ünvanlar ve menfaatlerin tek sahibinin Sarıkaya + Şahin olduğunu beyan ve taahhüt etmektesiniz. Web Sitesi’nin veya içeriğin kullanımının tüm şekilleri yasaktır.\n                ")])]), _c('br'), _vm._v(" "), _c('li', [_c('p', [_vm._v("Web Sitesi, Türkiye genelinde 5846 sayılı Fikir ve Sanat Eserleri Kanunu uyarınca ve dünya çapında uluslararası sözleşmeler, telif yasaları ve düzenlemeleri uyarınca korunmaktadır. Sarıkaya + Şahin’in açık yazılı ön izni olmaksızın Web Sitesi’nin içeriğini, tasarımını veya düzenini veya Web Sitesi’nin bağımsız bir bölümünün içeriğini, tasarımını veya düzenini değiştiremezsiniz, çoğaltamazsınız veya dağıtamazsınız.\n                ")])]), _c('br')])])])])])])])
}]}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(193)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(195),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5bbc6e51",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bulten',
  data: function data() {
    return {};
  },

  methods: {},
  mounted: function mounted() {}
});

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ourTeam"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-vertical"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent is-3 is-vertical"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("BÜLTEN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('div', {
    staticClass: "tile is-child  has-text-right is-size-1"
  }, [_c('h2')]), _vm._v(" "), _c('div', {
    staticClass: "tile columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h3', [_vm._v("KİŞİSEL VERİLERİ KORUMA KURUMU BAŞKANI, KESİLEN İDARİ PARA CEZALARI HAKKINDA BİLGİ VERDİ")]), _vm._v(" "), _c('span', [_vm._v("Tarih: 02.11.2017")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n                    TBMM Plan ve Bütçe Komisyonu'nda Kişisel Verileri Koruma Kurumu’nun (“Kurum”) bütçesi görüşüldü. Görüşmeler esnasında konuşan Kurum Başkanı Faruk Bilir, Kurum’un 2017 yılında 34 şikayet ve 7 ihbar olmak üzere toplam 41 başvuru aldığını, bu başvuruların 19'unun karara bağlandığını ve toplam 125 bin Türk Lirası tutarında idari para cezası kesildiğini açıkladı.")]), _vm._v(" "), _c('p', [_vm._v("\n                    Bilir ayrıca Kurum’un 2017 yılı içinde kendi bütçesi olmadığını ve Maliye Bakanlığının yedek ödeneğinden aktarılan 15 milyon Türk Lirası ile bütçe ihtiyaçlarını karşılamaya devam ettiklerini, çalışma ortamı ve personel ihtiyaçlarını karşılamak için 2018 yılında toplam 30 milyon 503 bin Türk Lirası ödenek talep edildiğini de ifade etti. Kurum’un bütçe ihtiyacı sebebiyle 2018 yılında idari para cezalarına ağırlık vermesi bekleniyor.")])])]), _vm._v(" "), _c('div', {
    staticClass: "tile columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h3', [_vm._v("\n                    KİŞİSEL VERİLERİN SİLİNMESİ, YOK EDİLMESİ VEYA ANONİM HALE GETİRİLMESİ HAKKINDA YÖNETMELİK RESMİ GAZETE’DE YAYIMLANDI")]), _vm._v(" "), _c('span', [_vm._v("Tarih: 28.10.2017")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n                    6698 Sayılı Kişisel Verilerin Korunması Kanunu (“Kanun”) madde 7/1 uyarınca; Kanun’a ve ilgili diğer kanunlara uygun olarak işlenmiş olmasına rağmen işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel veriler re’sen veya ilgili kişinin talebi üzerine veri sorumlusu tarafından silinmek, yok edilmek veya anonim hâle getirilmek zorundadır.")]), _vm._v(" "), _c('p', [_vm._v("\n                    Kanun madde 7/3 uyarınca; kişisel verilerin silinmesine, yok edilmesine veya anonim hâle getirilmesine ilişkin usul ve esaslar yönetmelikle düzenlenir. Bu kapsamda Kişisel Verileri Koruma Kurumu tarafından düzenlenen Kişisel Verilerin Silinmesi, Yok Edilmesi veya Anonim Hale Getirilmesi Hakkında Yönetmelik (“Yönetmelik”) 28 Ekim 2017 Cumartesi günü Resmi Gazete’de yayımlandı. Yönetmelik, 1 Ocak 2018 tarihinde yürürlüğe girecek ve uygulanmaya başlayacaktır.")]), _vm._v(" "), _c('p', [_vm._v("\n                    Yönetmelik, kişisel verilerin talep üzerine silinmesine ilişkin usulü, re’sen periyodik olarak silinmesine ilişkin uyulması gereken zorunlu süreleri, kişisel veri işleme envanteri ve kişisel verileri saklama ve imha politikası düzenleme zorunlulukları gibi kritik hususları içermektedir. Bu kapsamda;")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                      Veri sorumluları, iş süreçlerine bağlı olarak gerçekleştirmekte oldukları kişisel verileri işleme faaliyetlerini; kişisel verileri işleme amaçları, veri kategorisi, aktarılan alıcı grubu ve veri konusu kişi grubuyla ilişkilendirerek oluşturdukları ve kişisel verilerin işlendikleri amaçlar için gerekli olan azami süreyi, yabancı ülkelere aktarımı öngörülen kişisel verileri ve veri güvenliğine ilişkin alınan tedbirleri açıklayarak detaylandırdıkları bir kişisel veri işleme envanteri hazırlamak,\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                      Veri Sorumluları Siciline kayıt olmakla yükümlü olan veri sorumluları, kişisel veri işleme envanterine uygun olarak kişisel veri saklama ve imha politikası hazırlamak,\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                      Veri sorumluları, kişisel veri işleme envanteri ve politikalarına uygun olarak ve 6 ayı geçmeyecek şekilde periyodik olarak kişisel verileri imha etmek zorundadır.\n\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Sonuç olarak; veri sorumluların hem Kanun’a uyumlu hale gelebilmek hem de Yönetmelik kapsamında düzenlenen kişisel veri işleme envanteri ve kişisel veri saklama ve imha politikalarını hazırlayabilmek için kişisel veri süreçlerinin başından sonuna kadar inceleneceği bir hukuki iç denetimden geçmeleri ihtiyacı ortaya çıkmıştır.")])])]), _vm._v(" "), _c('div', {
    staticClass: "tile columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h3', [_vm._v("KİŞİSEL VERİLERİ KORUMA KURUMU’NDAN İLK CEZA")]), _vm._v(" "), _c('span', [_vm._v("Tarih: 12.10.2017")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n                    6698 sayılı Kişisel Verilerin Korunması Kanunu’nun (“Kanun”) yürürlüğe girmesi ile birlikte Kanun tarafından verilen görevleri yerine getirmek üzere, idari ve mali özerkliğe sahip ve kamu tüzel kişiliğini haiz Kişisel Verileri Koruma Kurumu (“Kurum”) kurulmuştu. Başbakanlık bünyesinde kurulan ve merkezi Ankara olan Kurum, faaliyetlerine başladı.")]), _vm._v(" "), _c('p', [_vm._v("\n                    Kanun uyarınca en çok merak edilen konuların başında olan idari para cezalarının Kurum tarafından ne zaman düzenleneceği hakkında hem ticari aktörler hem de hukukçular arasında bir bekleyiş bulunmaktaydı.")]), _vm._v(" "), _c('p', [_vm._v("\n                    Kurum’dan alınan bilgiye göre; ilk idari para cezası, Kanun madde 12 uyarınca kişisel verilerin güvenliğini sağlama yükümlülüğünü ihlal nedeniyle düzenlendi. Bu kapsamda kişisel veri işleyen özel veya tüzel tüm kişi ve kuruluşların veri güvenliğini sağlamak için tüm gerekli teknik tedbirleri almalarının önemi vurgulanmış oldu.")])])]), _vm._v(" "), _c('div', {
    staticClass: "tile columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h3', [_vm._v("KİŞİSEL VERİLERİN KORUNMASI HAKKINDA KANUN’DA DEĞİŞİKLİK")]), _vm._v(" "), _c('span', [_vm._v("Tarih: 05.10.2017")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n                    27 Eylül 2017 tarihli ve 884 sayılı kanun tasarısı (“Tasarı”) ile 6698 sayılı Kişisel Verilerin Korunması Kanunu'nda bir takım değişiklikler yapılması bekleniyor. Tasarının 123 ila 126. maddeleri ile getirilmesi beklenen yenilikler ve düzenlemeler aşağıdaki şekildedir:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                      Kişisel Verileri Koruma Kurumu (“Kurum”) bünyesinde oluşturulacak Veri Sorumluları Sicili’ne kayıt için ücret alınacağı düzenleniyor. Tasarının madde gerekçesinde İngiltere ve İrlanda gibi ülkelerde de sicile kayıt için ücret talep edildiği ifade ediliyor.\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                    Kurum’un ihtiyacı olan uzman atamalarının yapılması, Kurum bünyesinde hâkim ve savcıların görevlendirilmesi planlanıyor.\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h3', [_vm._v("AB HUKUKU KAPSAMINDA KİŞİSEL VERİLERİN KORUNMASI VE WEB ÇEREZLERİNİN KULLANIMI")]), _vm._v(" "), _c('span', [_vm._v("Tarih: 26.12.2014")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n                    Internet çerezleri, günümüz internet teknolojisinin işlemesinde önemli bir işlevi bulunmaktadır; ancak bununla birlikte internet kullanıcılarının gizliliğine ilişkin ciddi endişe de uyandırmaktadır. Bu nedenle Avrupa Birliği, internet kullanıcılarının kişisel verilerinin korunması yönündeki beklentilerini karşılamak için bazı web çerezlerinin kullanılabilmesi adına web sitelerinin kullanıcılardan bilgilendirilmiş rıza alınması zorunluluğunu getirdi. Ancak bu rızanın açık rıza veya zımni rıza mı olacağı ve hangi yöntemlerle alınacağı konusunda herhangi bir usul bulunmamaktadır.")]), _vm._v(" "), _c('p', [_vm._v("\n                    Dijital dünyada web kullanıcılarının rızasını almak konusunda değişik yöntemler uygulandığı görülmektedir. Bu yöntemlerden bazıları kanunlara uyum konusunda önemli adımlar atarken diğerleri kullanım deneyimini sekteye uğratmamak ve pratikliği ön plana çıkarmak için kanuni yükümlülükler konusunda gri alanlarda yer almaktadır.")]), _vm._v(" "), _c('p', [_vm._v("\n                    Rıza alabilmek için kullanılan başlıca metodlar aşağıdaki şekildedir.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                      açılan ekranlar (splash-screen),\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                    bant uyarılar (banner),\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                    sayfa ortasında beliren uyarılar (pop-up),\n                    ")]), _c('li', [_vm._v("\n                    aktivasyon butonları ve web tarayıcı varsayılan ayarlarının değiştirilmesi.\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("Bu yöntemlerden hangisinin seçilmesi gerektiği konusunda net çizgiler bulunmamaktadır ancak hukuki kanaatimiz, web sitesi yöneticilerinin öncelikle web sitelerinde yer alan çerezlerin hangi amaçlarla hangi verileri işlediğini tespit etmeleri ve bilişim hukukçuları ile işbirliği içerisinde web sayfalarını tasarlamalarının gerekli olduğudur.")])])])])])])])])])])
}]}

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(213),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(40);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(216),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ })
]),[41]);


// WEBPACK FOOTER //
// static/js/app.5d9d73cd21a8e7023545.js